import { Component, OnInit, OnChanges, OnDestroy, SimpleChanges, Input  } from '@angular/core';
import { Subscription } from 'rxjs';
import { WalletServiceService } from 'src/app/services/wallet/wallet-service.service';
import { Utils } from 'src/app/Models/Classes/utils';
import { Wallet } from 'src/app/Models/Classes/Wallet/wallet';
import { ModalController } from '@ionic/angular';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestService } from 'src/app/services/request/request.service';
import Swal from 'sweetalert2';
import { Capacitor, Plugins, registerPlugin } from '@capacitor/core';
import { NativeNearby } from 'src/app/plugins/native-runtime.plugins';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { Clipboard } from '@capacitor/clipboard';
import * as QRCode from 'qrcode';
import { PagoVerificacionComponent } from 'src/app/components/pago-verificacion/pago-verificacion.component';
import { SocialInteractionNotificationService } from 'src/app/services/notifications/social-interaction-notification.service';
import { COINPAYMENTS_V2_CURRENCIES } from './coinpayments-currencies';
import { QrCodeGeneratorComponent } from 'src/app/qr-code-generator/qr-code-generator.component';
import { HapticLanguageService } from 'src/app/services/ui/haptic-language.service';
import { RetirosPaypalComponent } from 'src/app/components/go-ecosystem/wallet-app/sections/retiros-paypal/retiros-paypal.component';

declare const TradingView: any;
const AppleWallet = registerPlugin<{ addPass(options: { base64: string }): Promise<{ opened: boolean }> }>('AppleWallet');
const { LocalNotifications } = Plugins;

interface HubbleTransferConfirmation {
  profileId: number;
  amount: number;
  currency: string;
  concept: string;
  recipientName: string;
  recipientUsername: string;
  recipientPhotoUrl: string;
  recipientVerified: boolean;
}

interface HubbleTransferReceipt {
  reference: string;
  amount: number;
  currency: string;
  concept: string;
  recipientName: string;
  recipientUsername: string;
  recipientPhotoUrl: string;
  completedAt: Date;
}

@Component({
	selector: 'app-wallet-app',
	templateUrl: './wallet-app.component.html',
	styleUrls: ['./wallet-app.component.scss'],
})
export class WalletAppComponent implements OnInit, OnChanges, OnDestroy {
  private readonly alibabaWalletCheckoutSessionKey = 'AlibabaWalletCheckoutState';
  private checkoutRouteSubscription?: Subscription;
	public profile: any = null;
  public isStandalonePage = false;
	//public profile_id: number;
	@Input() shortcut: any;
	@Input() objmedia: any;
	@Input() publication_id: any;
	@Input() TotalPayment: any;
	@Input() balances: any[];
	 @Input() transactions: any[];
	 @Input() profile_id: number;
	 public LaniakeaBalance: number;
   public transferSearchTerm: string = '';
   public transferRecipients: any[] = [];
   public selectedTransferRecipient: any = null;
   public transferAmount: number = null;
   public transferCurrency: string = 'MXN';
   public transferConcept: string = '';
   public transferLoading: boolean = false;
   public transferSearchLoading: boolean = false;
   public transferMessage: string = '';
  public transferError: string = '';
  public transferRecipientSource: 'manual' | 'qr' | 'nearby' = 'manual';
  public nearbyTransferLoading = false;
  public nearbyTransferAdvertising = false;
  public transferConfirmationOpen = false;
  public pendingTransferConfirmation: HubbleTransferConfirmation | null = null;
  public transferReceipt: HubbleTransferReceipt | null = null;
  public transferReceiptCopyLabel = 'Copiar referencia';
  public transferCooldownSeconds: number = 0;
   private transferSearchTimer: any = null;
   private transferCooldownTimer: any = null;
   private transferReceiptCopyTimer: any = null;
   private paymentPrefShortcutAllowed = false;
   public HubbleExpired: boolean = false;
   public isGlobalBalanceRefreshing: boolean = false;
   public balanceRateMXN: any[] = [];
  public balanceRateMXNByKey: Record<string, number> = {};
  public unavailableConversionKeys = new Set<string>();
   private walletRecords: any[] = [];
   private balanceSnapshot: Record<string, number> | null = null;
   public isLaniakeaBalanceLoading: boolean = false;
   public lastHubbleRefreshAt: Date | null = null;
   public loyaltyCardsActive: boolean = false;
   public loyaltyCards: any[] = [];
   public loyaltyCardsLoading: boolean = false;
   public loyaltyCardsError: string = '';
   public generatedLoyaltyClaimUrl: string = '';
   public generatedLoyaltyQrUrl: string = '';
   public generatedLoyaltyCard: any = null;
   public loyaltyCardDraft: any = {
      store_name: 'Laniakea Rewards',
      card_name: 'Rewards Pass',
      member_name: '',
      brand_image_url: '',
      notification_icon_url: '',
      money_amount: 0,
      currency_code: 'MXN',
      offer_message: '',
      change_message: 'Tu tarjeta se actualizó: %@',
      background_color: '#050a2f',
   };

   public hideBalance: boolean = false;
//
  // Conversion / cool UI state (restored click-on-currency feature from my-wallet)
  // Clicking a specific .hubble-chainrow opens the swap calculator + TradingView "cool ui"
  // styled to live inside the new design's hubble-blockchains without changing list graphics.
  conversionActive: boolean = false;
  conversionesMXN: boolean = false;
  conversionesBTC: boolean = false;
  conversionesUSDT: boolean = false;
  conversionesETH: boolean = false;
  conversionesLTC: boolean = false;
  conversionesXRP: boolean = false;
  conversionesDOGE: boolean = false;
  conversionesSHIB: boolean = false;
  conversionesBNB: boolean = false;
  conversionesSOL: boolean = false;
  currency1: string = "";
  currency2: string = "";
  amount1: number = 0;
  amount2: number = 0;
  conversionGrossAmount: number = 0;
  conversionCommissionAmount: number = 0;
  symbol: any;
  showCurrency1Select = false;
  showCurrency2Select = false;
  selectedChain: any = null;
  selectedCoinGroup: any = null;
  conversionViewMode: 'coin' | 'trade' = 'coin';
  public isPortfolioGlobalChartLoading = false;
  public portfolioGlobalChartError = '';
  public portfolioGlobalChartPolyline = '';
  public portfolioGlobalChartArea = '';
  public portfolioGlobalChartFirstLabel = '';
  public portfolioGlobalChartLastLabel = '';
  public portfolioGlobalChartMinLabel = '';
  public portfolioGlobalChartMaxLabel = '';
  public portfolioGlobalChartTrendUp = true;
  public portfolioGlobalTooltipVisible = false;
  public portfolioGlobalTooltipLeft = 0;
  public portfolioGlobalTooltipTop = 0;
  public portfolioGlobalTooltipDate = '';
  public portfolioGlobalTooltipValue = '';
  private portfolioGlobalChartTimer: any = null;
  private portfolioGlobalChartCacheKey = '';
  private portfolioGlobalChartRequestId = 0;
  private portfolioGlobalChartPoints: Array<{ label: string; value: number; x: number; y: number }> = [];
  private readonly portfolioHistoricalFetchLimit = 1;
  private readonly portfolioHistoricalDays = 90;
  private readonly coinGeckoIds: Record<string, string> = {
    BTC: 'bitcoin',
    ETH: 'ethereum',
    DOGE: 'dogecoin',
    XRP: 'ripple',
    BNB: 'binancecoin',
    SOL: 'solana',
    TRX: 'tron',
    SHIB: 'shiba-inu',
    BCH: 'bitcoin-cash',
    AVAX: 'avalanche-2',
    POL: 'polygon-ecosystem-token',
    DASH: 'dash',
    XMR: 'monero',
    PAXG: 'pax-gold',
    LINK: 'chainlink',
    'DOT.BEP20': 'polkadot',
    QTUM: 'qtum',
    RVN: 'ravencoin',
  };

	public available_sections: Array<string> = ["Blockchains", "History", "Transfer", "Payouts", "Payment Pref."];
	// Icons for the static Hubble tabs. Only Blockchains icon was correct.
	// History: timer/clock style for transaction history.
	// Payouts: reuses previous "history" icon (swap-horizontal).
	// Payment Pref.: reuses previous "payouts" icon (download-sharp).
	// All tab ion-icons made significantly larger in SCSS.
	public icons_for_sections: Array<string> = ["wallet", "time-outline", "send-outline", "swap-horizontal", "download-sharp"];
	public actual_section: string = "Blockchains";
	public initialPaymentMethod: string | null = null;
	constructor(
		public modalcontroller: ModalController,
		private walletService: WalletServiceService,
		private utils: Utils,
		private profile_service: ProfileService,
		public route: ActivatedRoute,
    private router: Router,
		private request: RequestService,
		private socialNotifications: SocialInteractionNotificationService,
		private haptics: HapticLanguageService,
	) {
			this.profile_id = this.route.snapshot.params.profile_id || (history.state && history.state.profile_id) || 0;
		 }

	ngOnInit() {
    const navigationState = this.router.getCurrentNavigation()?.extras?.state || history.state;
    const hasCheckoutNavigationState = this.hasCheckoutNavigationState(navigationState);
    this.applyNavigationState(navigationState);
    if (this.hasQueryParams() || hasCheckoutNavigationState) {
      this.applySessionCheckoutState();
    }
    this.applyQueryParams();
    // iOS can keep this routed component alive while a user returns to FEEX
    // and starts another checkout. Listen for each query-param navigation so
    // a previous cart's product and total never remain in payment preferences.
    this.checkoutRouteSubscription = this.route.queryParamMap.subscribe(() => {
      this.refreshCheckoutContextFromRoute();
    });
    if (navigationState) {
      this.profile_id = navigationState.profile_id || this.profile_id;
      this.transactions = navigationState.transactions ?? this.transactions;
      this.balances = navigationState.balances ?? this.balances;

      if (this.balances && this.balances.length > 0) {
        this.retrieveBalanceRateMXN();
      }
    }
    this.isStandalonePage = this.router.url.includes('/ecosystem-page/wallet');
		this.paymentPrefShortcutAllowed = this.hasExplicitCheckoutShortcut() || this.hasTapToPaySettingsShortcut();

		this.applyShortcutSectionState();
		/*this.utils.loadingPresent().then(() => {
		  this.walletService.refreshWallets().finally(() => {
			this.utils.loadingDismiss().catch((error) => {
			  console.error(error);
			});
		  });
		});
		*/
		//console.log('wallet app', this.profile.id);
		console.log('wallet app', this.profile_id);
		console.log('wallet app balances', this.balances);
		console.log('wallet app transactions', this.transactions);
		if(this.shortcut === 'Hipoteca' || this.shortcut === 'AutomobileLoan'){
			this.actual_section='Payouts';
		}
    this.ensureWalletDataOnInit();
    // Ensure clean init state for Blockchains (bullets, no loading/qubits/activity until user reveals via eye).
    if (this.actual_section === 'Blockchains') {
      this.isLaniakeaBalanceLoading = false;
      this.isGlobalBalanceRefreshing = false;
    }
    this.calculateGlobalBalance();
	  }

  private applyNavigationState(navigationState: any) {
    if (!navigationState) {
      return;
    }

    this.shortcut = navigationState.shortcut || this.shortcut;
    this.objmedia = navigationState.objmedia || this.objmedia;
    this.TotalPayment = navigationState.TotalPayment ?? this.TotalPayment;
    this.publication_id = navigationState.publication_id || this.publication_id;
  }

  private hasCheckoutNavigationState(navigationState: any): boolean {
    return !!(navigationState?.shortcut || navigationState?.objmedia || navigationState?.TotalPayment || navigationState?.publication_id);
  }

  private hasQueryParams(): boolean {
    return this.route.snapshot.queryParamMap.keys.length > 0;
  }

  private applySessionCheckoutState(force = false) {
    if (!force && this.objmedia && this.TotalPayment) {
      return;
    }

    try {
      const checkoutState = sessionStorage.getItem(this.alibabaWalletCheckoutSessionKey);
      if (!checkoutState) {
        return;
      }

      const parsedState = JSON.parse(checkoutState);
      this.shortcut = parsedState.shortcut || this.shortcut;
      this.objmedia = parsedState.objmedia || this.objmedia;
      this.TotalPayment = parsedState.TotalPayment ?? this.TotalPayment;
      this.publication_id = parsedState.publication_id || this.publication_id;
    } catch (error) {
      console.error('Error parsing Alibaba wallet checkout session state:', error);
    }
  }

  private applyShortcutSectionState() {
    if (this.shortcut === 'pagoDePublicacion') {
      this.available_sections = ["Payment Pref."];
      this.actual_section = 'Payment Pref.';
    } else if (this.shortcut === 'transfer') {
      this.actual_section = 'Transfer';
    }
  }

  /**
   * Replace—not merge—the checkout inputs after navigation to the same wallet
   * route. Merging was safe on web where this component is commonly rebuilt,
   * but iOS WebView can retain it and consequently reuse an earlier product
   * total for crypto conversion.
   */
  private refreshCheckoutContextFromRoute(): void {
    if (this.route.snapshot.queryParamMap.get('shortcut') !== 'pagoDePublicacion') {
      return;
    }

    this.shortcut = null;
    this.objmedia = null;
    this.TotalPayment = null;
    this.publication_id = null;

    this.applyQueryParams();
    this.applySessionCheckoutState(true);
    this.paymentPrefShortcutAllowed = this.hasExplicitCheckoutShortcut() || this.hasTapToPaySettingsShortcut();
    this.applyShortcutSectionState();
  }

	private applyQueryParams() {
	    const params = this.route.snapshot.queryParamMap;

	    const section = params.get('section');
	    if (section && this.available_sections.includes(section)) {
	      this.actual_section = section;
	    }

	    const paymentMethod = params.get('payment_method');
	    if (paymentMethod) {
	      this.initialPaymentMethod = paymentMethod;
	    }

    const shortcut = params.get('shortcut');
    if (shortcut) {
      this.shortcut = shortcut;
    }

    const totalPayment = params.get('TotalPayment');
    if (totalPayment !== null) {
      const parsedTotalPayment = Number(totalPayment);
      this.TotalPayment = Number.isNaN(parsedTotalPayment) ? totalPayment : parsedTotalPayment;
    }

    const publicationId = params.get('publication_id');
    if (publicationId) {
      this.publication_id = publicationId;
    }

    const profileId = params.get('profile_id');
    if (profileId) {
      const parsedProfileId = Number(profileId);
      this.profile_id = Number.isNaN(parsedProfileId) ? this.profile_id : parsedProfileId;
    }

    const objmedia = params.get('objmedia');
    if (objmedia) {
      try {
        this.objmedia = JSON.parse(objmedia);
      } catch (error) {
        console.error('Error parsing wallet objmedia query param:', error);
      }
    }
  }

  private async ensureWalletDataOnInit() {
    try {
      await this.ensureProfile();

      // Core logic: when we open the wallet app (standalone page), all data needs to be fetched fresh.
      // For embedded use with passed data, use it if present; but force fetch on standalone open.
      let forceFetchOnOpen = this.isStandalonePage || !this.hasWalletData();
      if (forceFetchOnOpen && this.actual_section === 'Blockchains') {
        // On initial render of Blockchains: do NOT auto-fetch or set loading flags.
        // Show clean hidden UI with bullets (as it "was perfect" on init). Nothing fetched until explicit reveal (eye click) or other tab.
        forceFetchOnOpen = false;
      }
      if (forceFetchOnOpen) {
        await this.fetchHubbleWalletData();
      } else if (this.balances && this.balances.length > 0 && this.actual_section !== 'Blockchains') {
        // Ensure we have rates even if data came from navigation (but not on Blockchains init - keep clean bullets, lazy until reveal)
        if (!this.balanceRateMXN || this.balanceRateMXN.length === 0) {
          this.retrieveBalanceRateMXN();
        } else {
          this.calculateGlobalBalance();
        }
      } else if (this.actual_section === 'Blockchains' && this.balances && this.balances.length > 0) {
        // For Blockchains init with pre-passed data: still compute the total (for other tabs) but do not set loading flags or trigger qubits.
        // calculate will set loading=false. UI will render bullets on init.
        this.calculateGlobalBalance();
      } else if (this.actual_section === 'Blockchains') {
        // Pure init for Blockchains, no data yet: ensure loading is false so no qubits, just bullets.
        this.isLaniakeaBalanceLoading = false;
        this.isGlobalBalanceRefreshing = false;
      }
    } catch (error) {
      console.error('Error initializing wallet data:', error);
    }
  }

  private async ensureProfile() {
    if (this.profile && this.profile_id) {
      return;
    }
    if (!this.profile_id) {
      // demo/screenshot mode: avoid calling backend without id
      this.profile = { id: 0, username: 'demo' };
      return;
    }

    const profileInfo = await this.profile_service.getProfileInfo(this.profile_id);
    const parsedProfile = this.parseMaybeJson(profileInfo);
    this.profile = parsedProfile;
    this.profile_id = parsedProfile?.id ?? this.profile_id;
    this.handleProfileResponseLoaded();
  }

  private handleProfileResponseLoaded() {
    this.syncCheckoutSessionForWalletRoute();
    this.enforcePaymentPrefAccessAfterProfileLoad();
  }

  private syncCheckoutSessionForWalletRoute() {
    if (this.shouldCleanCheckoutSession()) {
      try {
        sessionStorage.removeItem(this.alibabaWalletCheckoutSessionKey);
      } catch (error) {
        console.error('Error cleaning Alibaba wallet checkout session:', error);
      }
      this.clearCheckoutContext();
      return;
    }

    if (this.hasQueryParams()) {
      return;
    }

    this.applySessionCheckoutState();
	    this.paymentPrefShortcutAllowed = this.hasExplicitCheckoutShortcut() || this.hasTapToPaySettingsShortcut();
    this.applyShortcutSectionState();
  }

  private shouldCleanCheckoutSession(): boolean {
    return !this.hasQueryParams() && this.isVerifiedUser();
  }

  private clearCheckoutContext() {
    if (this.shortcut === 'pagoDePublicacion') {
      this.shortcut = null;
    }
    this.objmedia = null;
    this.TotalPayment = null;
    this.publication_id = null;
	    this.paymentPrefShortcutAllowed = this.hasExplicitCheckoutShortcut() || this.hasTapToPaySettingsShortcut();

    if (this.actual_section === 'Payment Pref.' && this.isPaymentPrefSectionLocked('Payment Pref.')) {
      this.actual_section = 'Blockchains';
    }

    if (this.available_sections.length === 1 && this.available_sections[0] === 'Payment Pref.') {
      this.available_sections = ["Blockchains", "History", "Transfer", "Payouts", "Payment Pref."];
    }
  }

  /** Leave a completed/cancelled FEEX purchase before opening a normal wallet flow. */
  private beginWalletPaymentPreference(shortcut: string): void {
    try {
      sessionStorage.removeItem(this.alibabaWalletCheckoutSessionKey);
    } catch (error) {
      console.error('Error clearing Alibaba wallet checkout session:', error);
    }

    this.objmedia = null;
    this.TotalPayment = null;
    this.publication_id = null;
    this.shortcut = shortcut;
    this.paymentPrefShortcutAllowed = this.hasExplicitCheckoutShortcut() || this.hasTapToPaySettingsShortcut();
    this.section_change('Payment Pref.');
  }

  private enforcePaymentPrefAccessAfterProfileLoad() {
    if (this.actual_section === 'Payment Pref.' && this.isPaymentPrefSectionLocked('Payment Pref.')) {
      this.actual_section = 'Blockchains';
    }
  }

  private hasWalletData(): boolean {
    return Array.isArray(this.balances) &&
      this.balances.length > 0 &&
      Array.isArray(this.transactions);
  }

  private hasCryptoBalances(): boolean {
    if (!Array.isArray(this.balances) || this.balances.length <= 1) {
      return false;
    }

    return this.balances.slice(1).some((balance: any) => {
      const key = balance ? Object.keys(balance)[0] : '';
      return (parseFloat(balance?.[key] ?? '0') || 0) > 0;
    });
  }

  private hasResolvedLaniakeaBalance(): boolean {
    if (!this.hasWalletData()) {
      return false;
    }

    if (this.LaniakeaBalance === undefined || this.LaniakeaBalance === null || Number.isNaN(Number(this.LaniakeaBalance))) {
      return false;
    }

    return !this.hasCryptoBalances() || (Array.isArray(this.balanceRateMXN) && this.balanceRateMXN.length > 0);
  }

  private async fetchHubbleWalletData() {
    if (!this.profile_id || this.HubbleExpired) {
      return;
    }
    if (this.profile_id === 0) {
      // demo mode, no real fetch
      return;
    }

    // Fetch has started: show real atomic qubitstream in Blockchains cells only during this window.
    this.isGlobalBalanceRefreshing = true;
    this.isLaniakeaBalanceLoading = true;

    this.HubbleExpired = true;
    Swal.fire({
      title: 'Procesando...',
      text: 'Hubble is processing.',
      icon: 'success',
      timer: 9900,
      timerProgressBar: true,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      background: '#010f4e'
    });

    try {
      const result = await this.request.createRequestGet('Hubble', null, { id: this.profile_id });
      const wallets = this.parseMaybeJson(result);

      if (Array.isArray(wallets) && wallets.length > 0) {
		this.walletRecords = wallets;
        this.transactions = wallets[0]?.transactions || [];
        this.balances = wallets.map((wallet) => wallet.balance);
		this.notifyIfFundsWereReceived(this.balances);
        console.log('Successfully fetched Hubble info.');
        console.log('Hubble info:', wallets);

        // Fetch rates and compute global summatory so all tabs have the proper total
        this.retrieveBalanceRateMXN();
        return;
      }

      console.log('No Hubble wallet results found.');
    } catch (error) {
      Swal.fire({
        title: 'Hubo un error al abrir la cartera...',
        text: 'Intenta de nuevo más tarde.',
        icon: 'error',
        timer: 3600,
        timerProgressBar: true,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        background: '#010f4e'
      });
      console.error('Error fetching Hubble info:', error);
    } finally {
      this.HubbleExpired = false;
    }
  }

  private parseMaybeJson(value: any): any {
    if (typeof value !== 'string') {
      return value;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  }

	private notifyIfFundsWereReceived(balances: any[]): void {
		const current: Record<string, number> = {};
		(balances || []).forEach((entry: any) => {
			if (!entry || typeof entry !== 'object') return;
			Object.keys(entry).forEach((key) => {
				const value = Number(entry[key]);
				if (Number.isFinite(value)) current[key] = value;
			});
		});

		if (this.balanceSnapshot) {
			const increases = Object.keys(current).filter(
				(key) => current[key] > Number(this.balanceSnapshot?.[key] || 0),
			);
			if (increases.length > 0) {
				const detail = increases
					.map((key) => `${(current[key] - Number(this.balanceSnapshot?.[key] || 0)).toFixed(8).replace(/\.?0+$/, '')} ${key.replace('currency_', '')}`)
					.join(', ');
				this.socialNotifications.notifyLocal(
					'Fondos recibidos',
					`Tu cartera Hubble aumentó${detail ? `: ${detail}` : '.'}`,
					{ event_type: 'funds_received' },
				);
			}
		}
		this.balanceSnapshot = current;
	}

  private parseConversionValue(response: any): number {
    if (typeof response === 'number') {
      return Number.isFinite(response) ? response : 0;
    }

    if (typeof response === 'string') {
      const floatMatch = response.match(/float\((.*)\)/);
      if (floatMatch) {
        const value = parseFloat(floatMatch[1] || '0');
        return Number.isFinite(value) ? value : 0;
      }

      const parsed = parseFloat(response);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    const value = Number(response?.value ?? response?.result ?? response?.amount ?? 0);
    return Number.isFinite(value) ? value : 0;
  }

  private isUsdLikeCurrency(currencyName: string): boolean {
    const currency = (currencyName || '').toUpperCase();
    return currency.startsWith('USDT.')
      || currency.startsWith('USDC.')
      || ['USDT', 'USDC', 'DAI', 'DAI.ERC20', 'PYUSD.ERC20'].includes(currency);
  }

  private async getConversionValue(currencyName: string, amount: number): Promise<number> {
    if (!amount || amount <= 0) {
      return 0;
    }

    if (this.isUsdLikeCurrency(currencyName)) {
      return this.getStablecoinMxnValue(currencyName, amount);
    }

    const params: { [key: string]: string | string[] } = {
      currency: currencyName,
      amount: amount.toString(),
    };

    const response = await this.request.createRequestGet('Conversiones', params);
    return this.parseConversionValue(response);
  }

  private async getStablecoinMxnValue(currencyName: string, amount: number): Promise<number> {
    const params: { [key: string]: string | string[] } = {
      currency: 'USD',
      amount: amount.toString(),
    };

    const response = await this.request.createRequestGet('Conversiones', params);
    const value = this.parseConversionValue(response);

    if (!value || value <= 0) {
      console.warn(`[Hubble] Stablecoin conversion returned 0 using USDT pair for ${currencyName}:`, response);
    }

    return value;
  }

  public retrieveBalanceRateMXN() {
    // Mark that rate/calc phase of fetch has started so Blockchains cells show the real atomic qubitstream (only while in progress).
    this.isGlobalBalanceRefreshing = true;
    this.isLaniakeaBalanceLoading = true;

    const currencyMap = {
      currency_2: 'BTC',
      currency_4: 'ETH',
      currency_7: 'DOGE',
      // currency_3: 'USDT', // v1 unqualified symbol; not accepted by v2
      currency_6: 'XRP',
      currency_11: 'BNB',
      currency_12: 'SOL',
      currency_13: 'TRX',
      currency_8: 'SHIB.ERC20',
      currency_14: 'BCH',
      currency_15: 'DAI.ERC20',
      currency_16: 'AVAX.BEP20',
      currency_17: 'POL',
      currency_18: 'DASH',
      // currency_10: 'D', // v1 asset; not accepted by v2
      // currency_19: 'XMR', // v1 asset; not accepted by v2
      currency_20: 'USDC.ERC20',
      // currency_21: 'PYUSD.ERC20', // v1 asset; not accepted by v2
      // currency_22: 'PAXG', // v1 asset; not accepted by v2
      // currency_23: 'LINK', // v1 asset; not accepted by v2
      // currency_24: 'DOT.BEP20', // v1 asset; not accepted by v2
      // currency_25: 'QTUM', // v1 asset; not accepted by v2
      // currency_26: 'RVN', // v1 asset; not accepted by v2
    };

    const balanceOrder = [
      'currency_2',
      'currency_4',
      'currency_7',
      'currency_3',
      'currency_6',
      'currency_11',
      'currency_12',
      'currency_13',
      'currency_8',
      'currency_14',
      'currency_15',
      'currency_16',
      'currency_17',
      'currency_18',
      'currency_10',
      'currency_19',
      'currency_20',
      'currency_21',
      'currency_22',
      'currency_23',
      'currency_24',
      'currency_25',
      'currency_26',
    ];

    const balances = this.balances ?? [];
    const balanceRateArray: number[] = [];
    const balanceRateByKey: Record<string, number> = {};
    const unavailableConversionKeys = new Set<string>();

    const requests = balances.map((balance: any) => {
      const currencyKey = Object.keys(balance)[0];
      const walletRecord = (this.walletRecords || []).find((wallet: any) => {
        return wallet?.balance && typeof wallet.balance === 'object' &&
          Object.prototype.hasOwnProperty.call(wallet.balance, currencyKey);
      });
      const walletCurrencyName = String(
        walletRecord?.currency?.name ?? walletRecord?.currency_name ?? walletRecord?.currency ?? ''
      ).trim().toUpperCase();
      const currencyName = currencyMap[currencyKey as keyof typeof currencyMap] || walletCurrencyName;
      if (currencyName) {
        const amount = Number(balance[currencyKey] ?? 0);
        const index = balanceOrder.indexOf(currencyKey);

        if (!amount || amount <= 0) {
          if (index >= 0) {
            balanceRateArray[index] = 0;
          }
          balanceRateByKey[currencyKey] = 0;
          return Promise.resolve(0);
        }

        return this.getConversionValue(currencyName, amount)
          .then((value: number) => {
            console.log(`balance rate for ${currencyKey}:`, value);

            if (!Number.isFinite(value) || value <= 0) {
              unavailableConversionKeys.add(currencyKey);
              value = 0;
            }

            if (index >= 0) {
              balanceRateArray[index] = value;
            }
            balanceRateByKey[currencyKey] = value;

            return value;
          })
          .catch((error: any) => {
            console.error('Conversion error:', error);
            unavailableConversionKeys.add(currencyKey);
            const index = balanceOrder.indexOf(currencyKey);
            if (index >= 0) {
              balanceRateArray[index] = 0;
            } else {
              balanceRateArray.push(0);
            }
            balanceRateByKey[currencyKey] = 0;
            return 0;
          });
      } else {
        console.error('Currency name is undefined for currencyKey:', currencyKey);
        return Promise.resolve(0);
      }
    });

    Promise.all(requests)
      .then(() => {
        console.log('Balance rates array:', balanceRateArray);
        this.balanceRateMXN = balanceRateArray;
        this.balanceRateMXNByKey = balanceRateByKey;
        this.unavailableConversionKeys = unavailableConversionKeys;
        this.calculateGlobalBalance();
        // Note: calculateGlobalBalance() will set isLaniakeaBalanceLoading = false at the end.
      })
      .catch((error: any) => {
        console.error('Error retrieving balance rates:', error);
        this.isLaniakeaBalanceLoading = false;
      })
      .finally(() => {
        // Fetch (balances + conversions) no longer in progress: render the original design/UI as it was.
        // Genuine 0 balances (post-calc) will now display as 0; normal values appear normally.
	        setTimeout(() => {
	          this.isGlobalBalanceRefreshing = false;
	          this.schedulePortfolioGlobalChartRefresh();
	        }, 220);
      });
  }

  public calculateGlobalBalance(): number {
    if (!this.balances || this.balances.length === 0) {
      this.LaniakeaBalance = 0;
      this.isLaniakeaBalanceLoading = false;
      return 0;
    }

    let total = 0;
    const balance1 = parseFloat(this.balances?.[0]?.currency_1 ?? '0');
    total += balance1;

    const keyedRates = Object.values(this.balanceRateMXNByKey || {});
    if (keyedRates.length > 0) {
      const ratesTotal = keyedRates.reduce((acc: number, rate: number) => acc + (Number(rate) || 0), 0);
      total += ratesTotal;
    } else if (this.balanceRateMXN && this.balanceRateMXN.length > 0) {
      const ratesTotal = this.balanceRateMXN.reduce((acc: number, rate: number) => acc + (rate || 0), 0);
      total += ratesTotal;
    }

	    this.LaniakeaBalance = total;
	    this.isLaniakeaBalanceLoading = false;
	    this.schedulePortfolioGlobalChartRefresh();
	    return total;
	  }

  // Config for the Hubble-style Blockchains list to match the new design graphic while being data-driven.
  // Uses only accurate non-emoji symbols/labels for the coins (no invented emojis). BNB/SOL/SHIB kept for graphic fidelity to liked design (even if 0 value).
  // ETH uses 'ETH' text (not Ξ symbol) for accuracy. Tether uses proper ₮ symbol. Last row is SHIB.
  public hubbleChains: Array<any> = [
    { id: 'mxn',  label: '$',   bg: '#111827', color: '#fff', fontSize: '19px', fontWeight: '800', balanceIndex: 0, key: 'currency_1', rateIndex: -1, unit: 'MXN' },
    { id: 'btc',  label: '₿',   bg: '#f7931a', color: '#fff', fontSize: '17px', fontWeight: '700', balanceIndex: 1, key: 'currency_2', rateIndex: 0,  unit: 'BTC' },
    { id: 'eth',  label: 'ETH', bg: '#627eea', color: '#fff', fontSize: '14px', fontWeight: '700', balanceIndex: 3, key: 'currency_4', rateIndex: 1, unit: 'ETH' },
    { id: 'doge', label: 'DOGE', bg: '#c2a633', color: '#111', fontSize: '11px', fontWeight: '800', balanceIndex: 6, key: 'currency_7', rateIndex: 2, unit: 'DOGE' },
    // v2 no longer accepts the unqualified USDT symbol; use an explicit network below.
    // { id: 'usdt', label: '₮', bg: '#26a17b', color: '#fff', fontSize: '21px', fontWeight: '700', balanceIndex: 2, key: 'currency_3', rateIndex: 3, unit: 'USDT' },
    { id: 'xrp', label: 'XRP', bg: '#23292f', color: '#fff', fontSize: '13px', fontWeight: '700', balanceIndex: 5, key: 'currency_6', rateIndex: 4, unit: 'XRP' },
    { id: 'bnb', label: 'BNB', bg: '#f3ba2f', color: '#111', fontSize: '11px', fontWeight: '700', balanceIndex: 10, key: 'currency_11', rateIndex: 5, unit: 'BNB' },
    { id: 'sol', label: 'SOL', bg: '#9945ff', color: '#fff', fontSize: '13px', fontWeight: '700', balanceIndex: 11, key: 'currency_12', rateIndex: 6, unit: 'SOL' },
    { id: 'trx', label: 'TRX', bg: '#ff0013', color: '#fff', fontSize: '13px', fontWeight: '700', balanceIndex: 12, key: 'currency_13', rateIndex: 7, unit: 'TRX' },
    { id: 'shib-erc20', label: 'SHIB', bg: '#f15a24', color: '#fff', fontSize: '9px', fontWeight: '700', balanceIndex: 7, key: 'currency_8', rateIndex: 8, unit: 'SHIB.ERC20' },
    { id: 'bch', label: 'BCH', bg: '#8dc351', color: '#111', fontSize: '13px', fontWeight: '800', balanceIndex: 13, key: 'currency_14', rateIndex: 9, unit: 'BCH' },
    { id: 'dai-erc20', label: 'DAI', bg: '#f5ac37', color: '#111', fontSize: '9px', fontWeight: '800', balanceIndex: 14, key: 'currency_15', rateIndex: 10, unit: 'DAI.ERC20' },
    { id: 'avax-bep20', label: 'AVAX', bg: '#e84142', color: '#fff', fontSize: '9px', fontWeight: '700', balanceIndex: 15, key: 'currency_16', rateIndex: 11, unit: 'AVAX.BEP20' },
    { id: 'pol', label: 'POL', bg: '#8247e5', color: '#fff', fontSize: '13px', fontWeight: '700', balanceIndex: 16, key: 'currency_17', rateIndex: 12, unit: 'POL' },
    { id: 'dash', label: 'DASH', bg: '#008de4', color: '#fff', fontSize: '11px', fontWeight: '700', balanceIndex: 17, key: 'currency_18', rateIndex: 13, unit: 'DASH' },
    // These legacy v1 assets are intentionally preserved as commented code.
    // { id: 'd', label: 'D', bg: '#4b5563', color: '#fff', fontSize: '16px', fontWeight: '800', balanceIndex: 9, key: 'currency_10', rateIndex: 14, unit: 'D' },
    // { id: 'xmr', label: 'XMR', bg: '#ff6600', color: '#fff', fontSize: '13px', fontWeight: '700', balanceIndex: 18, key: 'currency_19', rateIndex: 15, unit: 'XMR' },
    { id: 'usdc-erc20', label: 'USDC', bg: '#2775ca', color: '#fff', fontSize: '9px', fontWeight: '700', balanceIndex: 19, key: 'currency_20', rateIndex: 16, unit: 'USDC.ERC20' },
    // { id: 'pyusd-erc20', label: 'PYUSD', bg: '#142c8e', color: '#fff', fontSize: '10px', fontWeight: '700', balanceIndex: 20, key: 'currency_21', rateIndex: 17, unit: 'PYUSD.ERC20' },
    // { id: 'paxg', label: 'PAXG', bg: '#d4af37', color: '#111', fontSize: '11px', fontWeight: '800', balanceIndex: 21, key: 'currency_22', rateIndex: 18, unit: 'PAXG' },
    // { id: 'link', label: 'LINK', bg: '#2a5ada', color: '#fff', fontSize: '11px', fontWeight: '700', balanceIndex: 22, key: 'currency_23', rateIndex: 19, unit: 'LINK' },
    // { id: 'dot-bep20', label: 'DOT', bg: '#e6007a', color: '#fff', fontSize: '13px', fontWeight: '700', balanceIndex: 23, key: 'currency_24', rateIndex: 20, unit: 'DOT.BEP20' },
    // { id: 'qtum', label: 'QTUM', bg: '#2e9ad0', color: '#fff', fontSize: '10px', fontWeight: '700', balanceIndex: 24, key: 'currency_25', rateIndex: 21, unit: 'QTUM' },
    // { id: 'rvn', label: 'RVN', bg: '#384182', color: '#fff', fontSize: '13px', fontWeight: '700', balanceIndex: 25, key: 'currency_26', rateIndex: 22, unit: 'RVN' },
    // Every active v2 currency is also available in the Hubble selectors.
    // Existing rows above retain their balance indexes and visual design;
    // currencies without a legacy balance slot render as zero until a wallet
    // record for that exact v2 currency is returned.
    ...COINPAYMENTS_V2_CURRENCIES
      .filter((currency) => ![
        'BTC', 'ETH', 'DOGE', 'XRP', 'BNB', 'SOL', 'TRX', 'SHIB.ERC20',
        'BCH', 'DAI.ERC20', 'AVAX.BEP20', 'POL', 'DASH', 'USDC.ERC20'
      ].includes(currency.value))
      .map((currency) => ({
        id: `coinpayment-${currency.value.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
        label: currency.label,
        bg: '#101a3f',
        color: '#ffffff',
        fontSize: '10px',
        fontWeight: '700',
        balanceIndex: -1,
        key: `coinpayment_${currency.value}`,
        rateIndex: -1,
        unit: currency.value,
        isCoinpaymentCurrency: true,
      })),
    { id: 'loyalty-cards', label: '+', bg: '#0b122d', color: '#fff', fontSize: '27px', fontWeight: '300', balanceIndex: -1, key: 'loyalty_cards', rateIndex: -1, unit: 'LOYALTY', isLoyalty: true },
  ];
  public tradeCurrencySelectOptions = {
    header: 'Criptomonedas',
    cssClass: 'hubble-trade-currency-sheet'
  };
  private readonly tradableChainLabels: Record<string, string> = {
    'USDC.ERC20': 'USDC.ERC20',
    'SHIB.ERC20': 'SHIB.ERC20'
  };

  public getNativeBalance(chain: any): number {
    if (!chain || !this.balances || this.balances.length === 0) {
      return 0;
    }

    if (chain.isCoinGroup && Array.isArray(chain.variants)) {
      return chain.variants.reduce((total: number, variant: any) => {
        return total + Math.max(0, Number(this.getNativeBalance(variant)) || 0);
      }, 0);
    }

    const k = chain.key || '';
    const value = this.findBalanceValueByChain(chain);
    if (value !== null && value !== undefined) {
      return parseFloat(value) || 0;
    }

    const obj = this.findBalanceEntryByKey(k) || this.balances[chain.balanceIndex];
    const v = obj && k ? this.getBalanceValueFromEntry(obj, k, chain.unit) : 0;
    return parseFloat(v ?? '0') || 0;
  }

  public getTradableChains(): Array<any> {
    return this.hubbleChains.filter((chain) => chain.unit !== 'MXN' && chain.id !== 'd' && !chain.isLoyalty);
  }

  public getTransferChains(): Array<any> {
    return this.hubbleChains.filter((chain) => chain.id !== 'd' && !chain.isLoyalty);
  }

  /**
   * The landing view shows one row per coin. Network-qualified variants stay
   * available in the group's detail view and in every operation selector.
   */
  public getInitialHubbleChains(): Array<any> {
    const groups = new Map<string, any>();

    this.hubbleChains
      .filter((chain) => !chain.isLoyalty)
      .forEach((chain) => {
        const groupKey = this.getCoinGroupKey(chain.unit);
        if (!groups.has(groupKey)) {
          groups.set(groupKey, {
            id: groupKey === 'MXN' ? 'mxn' : `coin-group-${groupKey.toLowerCase()}`,
            label: groupKey,
            unit: groupKey,
            key: `coin_group_${groupKey}`,
            balanceIndex: -1,
            rateIndex: -1,
            isCoinGroup: true,
            variants: [],
          });
        }
        groups.get(groupKey).variants.push(chain);
      });

    const loyalty = this.hubbleChains.find((chain) => chain.isLoyalty);
    if (loyalty) {
      groups.set(loyalty.id, loyalty);
    }

    return Array.from(groups.values());
  }

  public getCoinGroupKey(currency: string): string {
    const normalized = (currency || '').trim().toUpperCase();
    return normalized.split('.')[0] || normalized;
  }

  public getCoinGroupSubtitle(group: any): string {
    const count = Array.isArray(group?.variants) ? group.variants.length : 0;
    return `${count} ${count === 1 ? 'blockchain' : 'blockchains'}`;
  }

  public getBlockchainLabel(currency: string): string {
    const normalized = (currency || '').trim().toUpperCase();
    const parts = normalized.split('.');
    return parts.length > 1 ? parts.slice(1).join('.') : 'Nativa';
  }

  public getTradableChainLabel(currency: string): string {
    return this.tradableChainLabels[currency] || currency;
  }

  public getChainAcronym(currency: string): string {
    return (currency || '').split('.')[0].toUpperCase();
  }

  public getChainCurrencyImageSrc(currency: string): string {
    const normalizedCurrency = (currency || 'BTC').toUpperCase();
    const imageMap: Record<string, string> = {
      BTC: 'https://static.wixstatic.com/media/8c5863_60142700e27647239fc3c4d628e683cd~mv2.png',
      ETH: 'https://static.wixstatic.com/media/8c5863_0e274522e44749b4b8bdb62cf4001d89~mv2.png',
      USDT: 'https://static.wixstatic.com/media/8c5863_9dfdf2faca044a42ba51b35e8c0cf981~mv2.png',
      USDC: 'https://static.wixstatic.com/media/8c5863_fd7f81d63a004a2db31b348596bceeb3~mv2.png',
      DOGE: 'https://static.wixstatic.com/media/8c5863_a762f086cc734de8b338d277bd5d02c6~mv2.png',
      XRP: 'https://static.wixstatic.com/media/8c5863_10d4c90169bc48d9b84c748745bd8294~mv2.png',
      BNB: 'https://static.wixstatic.com/media/8c5863_e428a0f873e044acbcabfddfed4eed43~mv2.png',
      'BNB.BSC': 'https://static.wixstatic.com/media/8c5863_e428a0f873e044acbcabfddfed4eed43~mv2.png',
      SOL: 'https://static.wixstatic.com/media/8c5863_4fe0ad91599142ca8633c2fbfe9313a0~mv2.png',
      TRX: 'https://static.wixstatic.com/media/8c5863_29bf6320d0e144c5adf7be160b396143~mv2.png',
      SHIB: 'https://static.wixstatic.com/media/8c5863_9bdc6dbe35654865aadaf04739eb3fcf~mv2.png',
      'SHIB.ERC20': 'https://static.wixstatic.com/media/8c5863_9bdc6dbe35654865aadaf04739eb3fcf~mv2.png',
      BCH: 'https://static.wixstatic.com/media/8c5863_d2551672601041e199f2995a540584a8~mv2.png',
      DAI: 'https://static.wixstatic.com/media/8c5863_01af583c31b74c4a80e1174894ef4174~mv2.png',
      'DAI.ERC20': 'https://static.wixstatic.com/media/8c5863_01af583c31b74c4a80e1174894ef4174~mv2.png',
      AVAX: 'https://static.wixstatic.com/media/8c5863_9c5cace4f93c45e2a7fb9fe1fa08aee4~mv2.png',
      'AVAX.BEP20': 'https://static.wixstatic.com/media/8c5863_9c5cace4f93c45e2a7fb9fe1fa08aee4~mv2.png',
      'USDC.ERC20': 'https://static.wixstatic.com/media/8c5863_fd7f81d63a004a2db31b348596bceeb3~mv2.png',
      POL: 'https://static.wixstatic.com/media/8c5863_b18f2adfc4f4442ba7548f8eb2919723~mv2.png',
      DASH: 'https://static.wixstatic.com/media/8c5863_c727a5ce0c644dbf880e231bd7372035~mv2.png',
      XMR: 'https://static.wixstatic.com/media/8c5863_be3279a0a9e5405180e86529b7e57e1b~mv2.png',
      'PYUSD.ERC20': 'https://static.wixstatic.com/media/8c5863_ea998b27b043407e8a351e2832304223~mv2.png',
      PAXG: 'https://static.wixstatic.com/media/8c5863_16b61b57a1fb4a62bfada5255412ca72~mv2.png',
      LINK: 'https://static.wixstatic.com/media/8c5863_e62833bfe95f4adca7a3ba0392730651~mv2.png',
      'DOT.BEP20': 'https://static.wixstatic.com/media/8c5863_7a185c37566d4cf8b56f31ad31435977~mv2.png',
      QTUM: 'https://static.wixstatic.com/media/8c5863_3c8e37c9fbcc4a00bd1475ac1755a6d5~mv2.png',
      RVN: 'https://static.wixstatic.com/media/8c5863_5fdcfa43e0054c0ebfa38b22160374d3~mv2.png',
    };

    return imageMap[normalizedCurrency] || imageMap[normalizedCurrency.split('.')[0]] || '';
  }

  public getChainCurrencyVisual(currency: string): { label: string; bg: string; color: string } {
    const normalizedCurrency = (currency || '').toUpperCase();
    const visualMap: Record<string, { label: string; bg: string; color: string }> = {
      MXN: { label: '$', bg: '#111827', color: '#ffffff' },
      BTC: { label: 'BTC', bg: '#f7931a', color: '#ffffff' },
      ETH: { label: 'ETH', bg: '#EDEFF0', color: '#111111' },
      USDT: { label: 'USDT', bg: '#419192', color: '#ffffff' },
      USDC: { label: 'USDC', bg: '#2552B8', color: '#ffffff' },
      DOGE: { label: 'DOGE', bg: '#c2a633', color: '#111111' },
      XRP: { label: 'XRP', bg: '#23292f', color: '#ffffff' },
      BNB: { label: 'BNB', bg: '#f3ba2f', color: '#111111' },
      'BNB.BSC': { label: 'BNB', bg: '#f3ba2f', color: '#111111' },
      SOL: { label: 'SOL', bg: '#000000', color: '#ffffff' },
      TRX: { label: 'TRX', bg: '#ff0013', color: '#ffffff' },
      SHIB: { label: 'SHIB', bg: '#D23C23', color: '#ffffff' },
      'SHIB.ERC20': { label: 'SHIB', bg: '#D23C23', color: '#ffffff' },
      BCH: { label: 'BCH', bg: '#8dc351', color: '#111111' },
      DAI: { label: 'DAI', bg: '#F4B731', color: '#111111' },
      'DAI.ERC20': { label: 'DAI', bg: '#F4B731', color: '#111111' },
      AVAX: { label: 'AVAX', bg: '#e84142', color: '#ffffff' },
      'AVAX.BEP20': { label: 'AVAX', bg: '#e84142', color: '#ffffff' },
      'USDC.ERC20': { label: 'USDC', bg: '#2552B8', color: '#ffffff' },
      POL: { label: 'POL', bg: '#630FED', color: '#ffffff' },
      DASH: { label: 'DASH', bg: '#008de4', color: '#ffffff' },
      D: { label: 'D', bg: '#4b5563', color: '#ffffff' },
      XMR: { label: 'XMR', bg: '#ff6600', color: '#ffffff' },
      'PYUSD.ERC20': { label: 'PYUSD', bg: '#000000', color: '#ffffff' },
      PAXG: { label: 'PAXG', bg: '#d4af37', color: '#111111' },
      LINK: { label: 'LINK', bg: '#ffffff', color: '#111111' },
      'DOT.BEP20': { label: 'DOT', bg: '#000000', color: '#ffffff' },
      QTUM: { label: 'QTUM', bg: '#1B42ED', color: '#ffffff' },
      RVN: { label: 'RVN', bg: '#384182', color: '#ffffff' },
      LOYALTY: { label: '+', bg: '#101a3f', color: '#ffffff' },
    };

    return visualMap[normalizedCurrency]
      || visualMap[normalizedCurrency.split('.')[0]]
      || { label: this.getChainAcronym(normalizedCurrency), bg: '#101a3f', color: '#ffffff' };
  }

  private findBalanceEntryByKey(key: string): any {
    if (!key || !this.balances || this.balances.length === 0) {
      return null;
    }

    return this.balances.find((entry: any) => entry && Object.prototype.hasOwnProperty.call(entry, key)) || null;
  }

  private getBalanceValueFromEntry(entry: any, key: string, unit?: string): any {
    if (!entry || !key) {
      return null;
    }

    const upperKey = key.toUpperCase();
    const upperUnit = (unit || '').toUpperCase();
    if (Object.prototype.hasOwnProperty.call(entry, key)) {
      return entry[key];
    }
    if (Object.prototype.hasOwnProperty.call(entry, upperKey)) {
      return entry[upperKey];
    }
    if (upperUnit && Object.prototype.hasOwnProperty.call(entry, upperUnit)) {
      return entry[upperUnit];
    }
    if (entry.balance && typeof entry.balance === 'object') {
      return this.getBalanceValueFromEntry(entry.balance, key, unit);
    }

    return null;
  }

  private findBalanceValueByChain(chain: any): any {
    const key = chain?.key || '';
    const unit = (chain?.unit || '').toUpperCase();
    const currencyId = Number(key.replace('currency_', ''));

    const balanceEntry = this.findBalanceEntryByKey(key);
    const balanceEntryValue = this.getBalanceValueFromEntry(balanceEntry, key, unit);
    if (balanceEntryValue !== null && balanceEntryValue !== undefined) {
      return balanceEntryValue;
    }

    const indexedEntry = this.balances?.[chain.balanceIndex];
    const indexedValue = this.getBalanceValueFromEntry(indexedEntry, key, unit);
    if (indexedValue !== null && indexedValue !== undefined) {
      return indexedValue;
    }

    const walletRecord = (this.walletRecords || []).find((wallet: any) => {
      const walletCurrencyId = Number(wallet?.currency_id ?? wallet?.currency?.id ?? wallet?.currencyId);
      const walletCurrencyName = String(wallet?.currency?.name ?? wallet?.currency_name ?? wallet?.currency ?? '').toUpperCase();
      return walletCurrencyId === currencyId || walletCurrencyName === unit;
    });

    if (walletRecord) {
      const walletValue = this.getBalanceValueFromEntry(walletRecord.balance, key, unit);
      if (walletValue !== null && walletValue !== undefined) {
        return walletValue;
      }
      // The Hubble endpoint returns each wallet balance as an object such as
      // { currency_123: 0.42 }. Dynamic v2 rows do not have a legacy
      // currency_N key, but their matched wallet has exactly one value.
      if (walletRecord.balance && typeof walletRecord.balance === 'object') {
        const values = Object.values(walletRecord.balance);
        if (values.length === 1) {
          return values[0];
        }
      }
      if (typeof walletRecord.balance === 'number' || typeof walletRecord.balance === 'string') {
        return walletRecord.balance;
      }
    }

    return null;
  }

  private getBalanceRateForChain(chain: any): number | null {
    const unit = (chain?.unit || '').toUpperCase();
    if (!unit) {
      return null;
    }

    const walletRecord = (this.walletRecords || []).find((wallet: any) => {
      const walletCurrency = String(
        wallet?.currency?.name ?? wallet?.currency_name ?? wallet?.currency ?? ''
      ).toUpperCase();
      return walletCurrency === unit;
    });
    const balanceKey = walletRecord?.balance && typeof walletRecord.balance === 'object'
      ? Object.keys(walletRecord.balance)[0]
      : null;

    if (balanceKey && Object.prototype.hasOwnProperty.call(this.balanceRateMXNByKey || {}, balanceKey)) {
      return Number(this.balanceRateMXNByKey[balanceKey]) || 0;
    }

    return null;
  }

  public getMxnValue(chain: any): number {
    if (!chain) return 0;
    if (chain.isCoinGroup && Array.isArray(chain.variants)) {
      return chain.variants.reduce((total: number, variant: any) => {
        return total + Math.max(0, Number(this.getMxnValue(variant)) || 0);
      }, 0);
    }
    if (chain.id === 'mxn') {
      return this.getNativeBalance(chain);
    }
    if (this.balanceRateMXNByKey && Object.prototype.hasOwnProperty.call(this.balanceRateMXNByKey, chain.key)) {
      return this.balanceRateMXNByKey[chain.key];
    }
    const walletRate = this.getBalanceRateForChain(chain);
    if (walletRate !== null) {
      return walletRate;
    }
    if (chain.rateIndex < 0 || !this.balanceRateMXN || this.balanceRateMXN[chain.rateIndex] == null) {
      return 0;
    }
    return this.balanceRateMXN[chain.rateIndex];
  }

  public hasUnavailableConversion(chain: any): boolean {
    if (!chain) return false;
    if (chain.isCoinGroup && Array.isArray(chain.variants)) {
      return chain.variants.some((variant: any) => this.hasUnavailableConversion(variant));
    }
    return this.unavailableConversionKeys.has(chain.key);
  }

  public getPortfolioDiversificationTotal(): number {
    return this.getInitialHubbleChains()
      .filter((chain) => chain.id !== 'd' && !chain.isLoyalty)
      .reduce((total: number, chain: any) => total + Math.max(0, Number(this.getMxnValue(chain)) || 0), 0);
  }

  public getPortfolioSegments(): Array<{ chain: any; value: number; percent: number; color: string }> {
    const total = this.getPortfolioDiversificationTotal();
    if (!total || total <= 0) {
      return [];
    }

    return this.getInitialHubbleChains()
      .filter((chain) => chain.id !== 'd' && !chain.isLoyalty)
      .map((chain) => {
        const value = Math.max(0, Number(this.getMxnValue(chain)) || 0);
        return {
          chain,
          value,
          percent: (value / total) * 100,
          color: this.getChainCurrencyVisual(chain.unit).bg,
        };
      })
      .filter((segment) => segment.value > 0)
      .sort((a, b) => b.value - a.value);
  }

  public getPortfolioDonutGradient(): string {
    const segments = this.getPortfolioSegments();
    if (segments.length === 0) {
      return 'conic-gradient(rgba(168, 192, 255, 0.22) 0deg 360deg)';
    }

    let cursor = 0;
    const stops = segments.map((segment) => {
      const start = cursor;
      const end = cursor + (segment.percent * 3.6);
      cursor = end;
      return `${segment.color} ${start.toFixed(2)}deg ${end.toFixed(2)}deg`;
    });

    return `conic-gradient(${stops.join(', ')})`;
  }

  public formatPortfolioPercent(percent: number): string {
    const value = Number(percent) || 0;
    if (value > 0 && value < 0.1) {
      return '<0.1%';
    }

    return `${value.toFixed(1).replace(/\.0$/, '')}%`;
  }

  public shouldShowPortfolioGlobalChart(): boolean {
    return this.actual_section === 'Blockchains' &&
      !this.conversionActive &&
      !this.loyaltyCardsActive &&
      this.hideBalance &&
      !this.isGlobalBalanceRefreshing &&
      !this.isLaniakeaBalanceLoading &&
      this.hasResolvedLaniakeaBalance() &&
      Number(this.LaniakeaBalance || 0) > 0 &&
      this.getPortfolioSegments().length > 0;
  }

  private schedulePortfolioGlobalChartRefresh(delay: number = 220): void {
    if (!this.shouldShowPortfolioGlobalChart()) {
      this.destroyPortfolioGlobalChart();
      return;
    }

    if (this.portfolioGlobalChartTimer) {
      clearTimeout(this.portfolioGlobalChartTimer);
    }

    this.portfolioGlobalChartTimer = setTimeout(() => {
      this.portfolioGlobalChartTimer = null;
      this.refreshPortfolioGlobalChart();
    }, delay);
  }

  private async refreshPortfolioGlobalChart(): Promise<void> {
    if (!this.shouldShowPortfolioGlobalChart()) {
      this.destroyPortfolioGlobalChart();
      return;
    }

    const cacheKey = this.getPortfolioGlobalChartCacheKey();
    if (this.portfolioGlobalChartPolyline && this.portfolioGlobalChartCacheKey === cacheKey) {
      return;
    }

    const requestId = ++this.portfolioGlobalChartRequestId;
    this.isPortfolioGlobalChartLoading = true;
    this.portfolioGlobalChartError = '';

    try {
      const points = await this.buildPortfolioGlobalHistoryPoints();
      if (requestId !== this.portfolioGlobalChartRequestId || !this.shouldShowPortfolioGlobalChart()) {
        return;
      }

      if (!points.length) {
        this.portfolioGlobalChartError = 'Sin datos suficientes para graficar el portafolio.';
        this.destroyPortfolioGlobalChart(false);
        return;
      }

      this.renderPortfolioGlobalChart(points);
      this.portfolioGlobalChartCacheKey = cacheKey;
    } catch (error) {
      console.error('[Hubble] Portfolio global chart failed:', error);
      this.portfolioGlobalChartError = 'No se pudo cargar la grafica del portafolio.';
      this.destroyPortfolioGlobalChart(false);
    } finally {
      if (requestId === this.portfolioGlobalChartRequestId) {
        this.isPortfolioGlobalChartLoading = false;
      }
    }
  }

  private destroyPortfolioGlobalChart(clearState: boolean = true): void {
    if (this.portfolioGlobalChartTimer) {
      clearTimeout(this.portfolioGlobalChartTimer);
      this.portfolioGlobalChartTimer = null;
    }

    if (clearState) {
      this.portfolioGlobalChartError = '';
      this.portfolioGlobalChartCacheKey = '';
    }
    this.portfolioGlobalChartPolyline = '';
    this.portfolioGlobalChartArea = '';
    this.portfolioGlobalChartFirstLabel = '';
    this.portfolioGlobalChartLastLabel = '';
    this.portfolioGlobalChartMinLabel = '';
    this.portfolioGlobalChartMaxLabel = '';
    this.portfolioGlobalTooltipVisible = false;
    this.portfolioGlobalChartPoints = [];
    this.isPortfolioGlobalChartLoading = false;
  }

  private getPortfolioGlobalChartCacheKey(): string {
    return this.getPortfolioChartAssets()
      .map((asset) => `${asset.chain.unit}:${asset.balance}:${asset.currentValue}`)
      .join('|');
  }

  private getPortfolioChartAssets(): Array<{ chain: any; balance: number; currentValue: number; historical: boolean }> {
    const positiveAssets = this.getInitialHubbleChains()
      .filter((chain) => chain.id !== 'd' && !chain.isLoyalty)
      .map((chain) => ({
        chain,
        balance: Math.max(0, Number(this.getNativeBalance(chain)) || 0),
        currentValue: Math.max(0, Number(this.getMxnValue(chain)) || 0),
        historical: false,
      }))
      .filter((asset) => asset.currentValue > 0)
      .sort((a, b) => b.currentValue - a.currentValue);

    let historicalCount = 0;
    return positiveAssets.map((asset) => {
      const unit = (asset.chain.unit || '').toUpperCase();
      const canFetchHistory = unit !== 'MXN' &&
        !this.isUsdLikeCurrency(unit) &&
        !!this.coinGeckoIds[unit] &&
        asset.balance > 0 &&
        historicalCount < this.portfolioHistoricalFetchLimit;

      if (canFetchHistory) {
        historicalCount += 1;
      }

      return {
        ...asset,
        historical: canFetchHistory,
      };
    });
  }

  private async buildPortfolioGlobalHistoryPoints(): Promise<Array<{ label: string; value: number }>> {
    const assets = this.getPortfolioChartAssets();
    if (!assets.length) {
      return [];
    }

    const labels = this.buildPortfolioDateLabels();
    const totals = labels.map(() => 0);

    await Promise.all(assets.map(async (asset) => {
      if (!asset.historical) {
        labels.forEach((_, index) => {
          totals[index] += asset.currentValue;
        });
        return;
      }

      const priceHistory = await this.fetchCoinGeckoDailyMxnPrices(asset.chain.unit);
      labels.forEach((label, index) => {
        const price = priceHistory[label];
        totals[index] += price && price > 0 ? price * asset.balance : asset.currentValue;
      });
    }));

    const points = labels.map((label, index) => ({
      label,
      value: Number(totals[index].toFixed(2)),
    }));

    const currentTotal = Number(this.LaniakeaBalance || 0);
    const lastValue = points[points.length - 1]?.value || 0;
    if (currentTotal > 0 && lastValue > 0) {
      const scale = currentTotal / lastValue;
      points.forEach((point) => {
        point.value = Number((point.value * scale).toFixed(2));
      });
      points[points.length - 1].value = Number(currentTotal.toFixed(2));
    }

    return points;
  }

  private buildPortfolioDateLabels(): string[] {
    const labels: string[] = [];
    for (let index = this.portfolioHistoricalDays - 1; index >= 0; index--) {
      const date = new Date();
      date.setDate(date.getDate() - index);
      date.setHours(0, 0, 0, 0);
      labels.push(this.toPortfolioDateKey(date));
    }
    return labels;
  }

  private async fetchCoinGeckoDailyMxnPrices(unit: string): Promise<Record<string, number>> {
    const normalizedUnit = (unit || '').toUpperCase();
    const coinId = this.coinGeckoIds[normalizedUnit];
    if (!coinId) {
      return {};
    }

    const url = `https://api.coingecko.com/api/v3/coins/${coinId}/market_chart?vs_currency=mxn&days=${this.portfolioHistoricalDays}&interval=daily`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`CoinGecko ${normalizedUnit} ${response.status}`);
      }

      const data = await response.json();
      const prices = Array.isArray(data?.prices) ? data.prices : [];
      return prices.reduce((acc: Record<string, number>, point: any[]) => {
        const date = new Date(Number(point?.[0]));
        const price = Number(point?.[1]) || 0;
        if (!Number.isNaN(date.getTime()) && price > 0) {
          acc[this.toPortfolioDateKey(date)] = price;
        }
        return acc;
      }, {});
    } catch (error) {
      console.warn(`[Hubble] Historical price unavailable for ${normalizedUnit}; using flat current value.`, error);
      return {};
    }
  }

  private renderPortfolioGlobalChart(points: Array<{ label: string; value: number }>): void {
    const chartWidth = 320;
    const chartHeight = 150;
    const topPadding = 12;
    const bottomPadding = 18;
    const values = points.map((point) => point.value);
    const min = Math.min(...values);
    const max = Math.max(...values);
    const range = Math.max(1, max - min);
    const first = points[0]?.value || 0;
    const last = points[points.length - 1]?.value || 0;
    this.portfolioGlobalChartTrendUp = last >= first;

    this.portfolioGlobalChartPoints = points.map((point, index) => {
      const x = points.length <= 1 ? 0 : (index / (points.length - 1)) * chartWidth;
      const normalized = (point.value - min) / range;
      const y = topPadding + (1 - normalized) * (chartHeight - topPadding - bottomPadding);
      return {
        ...point,
        x,
        y,
      };
    });

    const svgPoints = this.portfolioGlobalChartPoints.map((point) => `${point.x.toFixed(2)},${point.y.toFixed(2)}`);

    this.portfolioGlobalChartPolyline = svgPoints.join(' ');
    this.portfolioGlobalChartArea = `M ${svgPoints[0]} L ${svgPoints.slice(1).join(' L ')} L ${chartWidth},${chartHeight} L 0,${chartHeight} Z`;
    this.portfolioGlobalChartFirstLabel = this.formatPortfolioDateLabel(points[0]?.label);
    this.portfolioGlobalChartLastLabel = this.formatPortfolioDateLabel(points[points.length - 1]?.label);
    this.portfolioGlobalChartMinLabel = `$${this.formatCompactMxn(min)}`;
    this.portfolioGlobalChartMaxLabel = `$${this.formatCompactMxn(max)}`;
  }

  public onPortfolioGlobalChartPointer(event: MouseEvent | TouchEvent): void {
    if (!this.portfolioGlobalChartPoints.length) {
      return;
    }

    const target = event.currentTarget as HTMLElement | null;
    if (!target) {
      return;
    }

    const rect = target.getBoundingClientRect();
    const clientX = event instanceof TouchEvent ? event.touches?.[0]?.clientX : event.clientX;
    if (clientX === undefined || rect.width <= 0) {
      return;
    }

    const relativeX = Math.max(0, Math.min(rect.width, clientX - rect.left));
    const chartX = (relativeX / rect.width) * 320;
    const nearest = this.portfolioGlobalChartPoints.reduce((best, point) => {
      return Math.abs(point.x - chartX) < Math.abs(best.x - chartX) ? point : best;
    }, this.portfolioGlobalChartPoints[0]);

    this.portfolioGlobalTooltipVisible = true;
    this.portfolioGlobalTooltipLeft = Math.max(6, Math.min(94, (nearest.x / 320) * 100));
    this.portfolioGlobalTooltipTop = Math.max(12, Math.min(78, (nearest.y / 150) * 100));
    this.portfolioGlobalTooltipDate = this.formatPortfolioDateLabel(nearest.label);
    this.portfolioGlobalTooltipValue = `$${this.formatMoney(nearest.value)} MXN`;
  }

  public hidePortfolioGlobalChartTooltip(): void {
    this.portfolioGlobalTooltipVisible = false;
  }

  private toPortfolioDateKey(date: Date): string {
    return date.toISOString().slice(0, 10);
  }

  private formatCompactMxn(value: number): string {
    return new Intl.NumberFormat('en-US', {
      notation: 'compact',
      maximumFractionDigits: 2,
    }).format(value || 0);
  }

  private formatMoney(value: number): string {
    return new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    }).format(value || 0);
  }

  private formatPortfolioDateLabel(value: string): string {
    if (!value) {
      return '';
    }

    const date = new Date(`${value}T00:00:00`);
    if (Number.isNaN(date.getTime())) {
      return value;
    }

    return new Intl.DateTimeFormat('es-MX', {
      month: 'short',
      day: 'numeric',
    }).format(date);
  }

  // Smart per-piece readiness (data-driven, not just global flag).
  // This makes the UI accurate to the actual fetch phases:
  // - Native balances (left / chainname) can appear as soon as the wallets response arrives.
  // - Converted MXN values on the right appear after their specific conversion rate is back.
  // - LaniakeaBalance (eyebar total) is only "ready" after the final calculation step.
  public isNativeBalanceReady(chain: any): boolean {
    if (!chain) return false;
    if (chain.isCoinGroup && Array.isArray(chain.variants)) {
      return chain.variants.every((variant: any) => this.isNativeBalanceReady(variant));
    }
    if (chain.balanceIndex < 0) {
      // Placeholders (BNB, SOL etc.) have no real data. "Ready" (show 0 or bullet) only when NOT in an active refresh/fetch.
      // During active loading (after eye click to reveal), return false so qubitstream shows "the actual fetch" for them too.
      return !this.isGlobalBalanceRefreshing && !this.isLaniakeaBalanceLoading;
    }
    if (!this.balances || this.balances.length === 0) {
      return false;
    }

    return !!this.findBalanceEntryByKey(chain.key) || !!this.balances[chain.balanceIndex];
  }

  public isConvertedValueReady(chain: any): boolean {
    if (!chain) return false;
    if (chain.id === 'mxn') {
      // MXN right side is the special "depositar MXN" CTA, not a rate-based value.
      return true;
    }
    if (chain.rateIndex < 0) {
      // Placeholders (BNB, SOL etc. in val column): "ready" (show 0 or bullet) only when NOT actively loading.
      // During fetch after eye click, show qubit instead of immediately 0.
      return !this.isGlobalBalanceRefreshing && !this.isLaniakeaBalanceLoading;
    }
    if (this.balanceRateMXNByKey && Object.prototype.hasOwnProperty.call(this.balanceRateMXNByKey, chain.key)) {
      return this.balanceRateMXNByKey[chain.key] != null;
    }
    if (!this.balanceRateMXN || this.balanceRateMXN.length <= chain.rateIndex) {
      return false;
    }
    const rate = this.balanceRateMXN[chain.rateIndex];
    return rate != null;
  }

  public onSectionTabClick(event: Event, section: string) {
    if (this.isPaymentPrefSectionLocked(section)) {
      event.preventDefault();
      event.stopPropagation();
      this.showPaymentPreferencesVerificationAlert();
      return;
    }

    this.section_change(section);
  }

	section_change(filtro) {
		if (filtro === 'Mi Cartera') {
			filtro = 'Blockchains';
		}
    if (this.isPaymentPrefSectionLocked(filtro)) {
      this.showPaymentPreferencesVerificationAlert();
      return;
    }
		this.actual_section = filtro;

		if (filtro !== 'Blockchains') {
			this.closeConversionUI();
		}

		const needsLaniakeaBalance = filtro === 'History' || filtro === 'Transfer' || filtro === 'Payouts' || filtro === 'Payment Pref.';
		if (needsLaniakeaBalance && !this.hasResolvedLaniakeaBalance() && !this.hasWalletData()) {
			// Fetch when switching to these tabs if LaniakeaBalance / wallet data not present
			// (e.g. partial navigation state or init not yet complete).
			// Core logic: on wallet open (ensureWalletDataOnInit) all data is fetched once.
			this.refreshHubbleData(true);
		} else if (!this.hasResolvedLaniakeaBalance() && this.balances && this.balances.length > 0 && (!this.balanceRateMXN || this.balanceRateMXN.length === 0)) {
			this.retrieveBalanceRateMXN();
		} else if (!this.hasResolvedLaniakeaBalance()) {
			this.calculateGlobalBalance();
		}

			// Extra freshness when entering the main balances view
			if (filtro === 'Blockchains' && !this.hasResolvedLaniakeaBalance()) {
				this.refreshHubbleData(true);
			}
			if (filtro === 'Blockchains') {
				this.schedulePortfolioGlobalChartRefresh();
			} else {
				this.destroyPortfolioGlobalChart();
			}
      if (filtro === 'Transfer' && this.transferRecipients.length === 0 && !this.selectedTransferRecipient) {
        this.searchTransferRecipients();
      }
		}

  public onTransferSearchChange(event: any) {
    const value = typeof event === 'string' ? event : (event?.detail?.value ?? event?.target?.value ?? '');
    this.transferSearchTerm = value;
    this.selectedTransferRecipient = null;
    this.transferRecipientSource = 'manual';
    this.transferMessage = '';
    this.transferError = '';
    this.transferReceipt = null;

    if (this.transferSearchTimer) {
      clearTimeout(this.transferSearchTimer);
    }

    this.transferSearchTimer = setTimeout(() => {
      this.searchTransferRecipients();
    }, 350);
  }

  public async searchTransferRecipients() {
    const query = (this.transferSearchTerm || '').trim();
    this.transferRecipients = [];

    this.transferSearchLoading = true;
    this.transferError = '';

    try {
      const response = await this.request.createRequestGet('search_page_unauth', {
        filter: 'Cuentas',
        searchTerm: query,
        page: '1',
      });
      const parsed = this.parseMaybeJson(response);
      const items = this.normalizeSearchResults(parsed);
      this.transferRecipients = items.filter((item) => {
        const profileId = Number(item?.user_info?.profile_id || 0);
        return profileId && profileId !== Number(this.profile_id);
      });
    } catch (error) {
      console.error('Error searching transfer recipients:', error);
      this.transferError = 'No se pudieron cargar usuarios de Laniakea.';
    } finally {
      this.transferSearchLoading = false;
    }
  }

  private normalizeSearchResults(data: any): any[] {
    if (!data) {
      return [];
    }

    if (Array.isArray(data)) {
      return data;
    }

    if (data.current_page !== undefined) {
      return Array.isArray(data.data) ? data.data : Object.values(data.data || {});
    }

    if (data.data) {
      return Array.isArray(data.data) ? data.data : Object.values(data.data || {});
    }

    return [];
  }

  public selectTransferRecipient(recipient: any) {
    this.selectedTransferRecipient = recipient;
    this.transferSearchTerm = recipient?.user_info?.username || recipient?.user_info?.full_name || this.transferSearchTerm;
    this.transferMessage = '';
    this.transferError = '';
  }

  public clearTransferRecipient(): void {
    this.selectedTransferRecipient = null;
    this.transferSearchTerm = '';
    this.transferRecipientSource = 'manual';
    this.transferMessage = '';
    this.transferError = '';
  }

  /**
   * Lets the other phone discover this profile over BLE. The transmitted
   * characteristic contains only a random server token, never the wallet ID.
   */
  public async advertiseNearbyTransferRecipient(): Promise<void> {
    this.transferError = '';
    this.transferMessage = '';
    this.nearbyTransferLoading = true;

    try {
      const availability = await NativeNearby.isAvailable();
      if (!availability?.available) {
        this.transferError = 'Bluetooth Nearby is available in the Laniakea mobile app. Use QR or search on this device.';
        return;
      }

      const rawSession = await this.request.createRequestPost('hubble/nearby/sessions', {});
      const session = this.parseMaybeJson(rawSession);
      const token = String(session?.token || '').trim();
      if (!token) throw new Error('The server did not create a nearby session.');

      await NativeNearby.advertise({ token });
      this.nearbyTransferAdvertising = true;
      this.transferMessage = 'Nearby is active for two minutes. Ask the sender to tap “Find nearby”.';
    } catch (error: any) {
      console.error('Unable to advertise nearby Hubble recipient:', error);
      this.transferError = error?.message || 'Unable to start Bluetooth Nearby. Use QR or search instead.';
    } finally {
      this.nearbyTransferLoading = false;
    }
  }

  /** Finds one nearby Laniakea phone and resolves its opaque session token. */
  public async findNearbyTransferRecipient(): Promise<void> {
    this.transferError = '';
    this.transferMessage = '';
    this.nearbyTransferLoading = true;

    try {
      const availability = await NativeNearby.isAvailable();
      if (!availability?.available) {
        this.transferError = 'Bluetooth Nearby is available in the Laniakea mobile app. Use QR or search on this device.';
        return;
      }

      const nearby = await NativeNearby.scan({ timeoutMs: 30000 });
      const token = String(nearby?.token || '').trim();
      if (!token) throw new Error('No nearby Laniakea profile was found.');

      const rawRecipient = await this.request.createRequestPost('hubble/nearby/resolve', { token });
      const result = this.parseMaybeJson(rawRecipient);
      const profileId = Number(result?.profile_id || 0);
      if (!profileId) throw new Error('The nearby session is no longer available. Ask the recipient to share again.');

      await this.applyTransferRecipientProfileId(profileId, 'nearby');
    } catch (error: any) {
      console.error('Unable to find nearby Hubble recipient:', error);
      this.transferError = error?.message || 'Unable to find a nearby recipient. Use QR or search instead.';
    } finally {
      try { await NativeNearby.stop(); } catch (_) { /* no active BLE scan */ }
      this.nearbyTransferLoading = false;
    }
  }

  public async stopAdvertisingNearbyTransferRecipient(): Promise<void> {
    try { await NativeNearby.stop(); } catch (_) { /* already stopped */ }
    this.nearbyTransferAdvertising = false;
    this.transferMessage = '';
  }

  public async scanTransferRecipientWithQr(): Promise<void> {
    this.transferError = '';
    const modal = await this.modalcontroller.create({
      component: QrCodeGeneratorComponent,
      componentProps: { scanMode: 'profile-transfer' },
      cssClass: 'detailsInModal',
      canDismiss: true,
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data?.payload) await this.applyTransferRecipientPayload(data.payload, 'qr');
  }

  private async applyTransferRecipientPayload(
    rawPayload: string,
    source: 'qr',
  ): Promise<void> {
    const profileId = this.profileIdFromSharePayload(rawPayload);
    if (!profileId) {
      this.transferError = 'El código QR no contiene un perfil de Laniakea válido.';
      return;
    }
    await this.applyTransferRecipientProfileId(profileId, source);
  }

  private async applyTransferRecipientProfileId(
    profileId: number,
    source: 'qr' | 'nearby',
  ): Promise<void> {
    if (profileId === Number(this.profile_id)) {
      this.transferError = 'No puedes enviar Hubble a tu propio perfil.';
      return;
    }

    this.transferSearchTerm = String(profileId);
    await this.searchTransferRecipients();
    const recipient = this.transferRecipients.find((item) =>
      Number(item?.user_info?.profile_id || item?.profile_id || item?.id || 0) === profileId
    );
    if (recipient) {
      this.selectTransferRecipient(recipient);
      this.transferRecipientSource = source;
      return;
    }
    this.transferError = 'No pudimos encontrar ese perfil. Busca por nombre o usuario.';
  }

  private profileIdFromSharePayload(payload: string): number | null {
    const value = String(payload || '').trim();
    if (!value) return null;
    const match = value.match(/(?:^|\/)profile\/(\d+)(?:\/|$|[?#])/i);
    return match ? Number(match[1]) : null;
  }

  public getSelectedTransferRecipientName(): string {
    return this.selectedTransferRecipient?.user_info?.full_name || this.selectedTransferRecipient?.user_info?.username || '';
  }

  public getSelectedTransferRecipientUsername(): string {
    const username = this.selectedTransferRecipient?.user_info?.username || '';
    return username ? `@${username}` : '';
  }

  /** Keep the Hubble recipient list consistent with the verified badge used by Search. */
  public isTransferRecipientVerified(recipient: any): boolean {
    const profile = recipient?.user_info || recipient || {};
    return profile?.Verificacion === 3
      || profile?.Verificacion === '3'
      || profile?.Verificacion === true;
  }

  public getTransferRecipientPhotoUrl(recipient: any): string {
    const photo = recipient?.user_info?.photo;
    if (!photo) {
      return 'https://laniakea-multimedia.s3.amazonaws.com/imagenes/profile_default.png';
    }

    if (/^https?:\/\//i.test(photo)) {
      return photo;
    }

    return `https://laniakea-multimedia.s3.amazonaws.com/${photo}`;
  }

  public onTransferRecipientImageError(event: Event) {
    const imageElement = event.target as HTMLImageElement;
    if (imageElement) {
      imageElement.src = 'https://laniakea-multimedia.s3.amazonaws.com/imagenes/profile_default.png';
    }
  }

  private startTransferCooldown(seconds: number = 30) {
    this.transferCooldownSeconds = Math.max(0, Math.ceil(Number(seconds) || 30));

    if (this.transferCooldownTimer) {
      clearInterval(this.transferCooldownTimer);
    }

    this.transferCooldownTimer = setInterval(() => {
      this.transferCooldownSeconds = Math.max(0, this.transferCooldownSeconds - 1);
      if (this.transferCooldownSeconds <= 0 && this.transferCooldownTimer) {
        clearInterval(this.transferCooldownTimer);
        this.transferCooldownTimer = null;
      }
    }, 1000);
  }

  public isTransferSubmitDisabled(): boolean {
    return this.transferLoading || this.transferConfirmationOpen || this.transferCooldownSeconds > 0;
  }

  public getTransferSubmitLabel(): string {
    if (this.transferLoading) {
      return 'Enviando...';
    }

    if (this.transferCooldownSeconds > 0) {
      return `Espera ${this.transferCooldownSeconds}s`;
    }

    return 'Enviar transferencia';
  }

  public async submitHubbleTransfer() {
    if (this.transferLoading || this.transferConfirmationOpen) {
      return;
    }

    if (this.transferCooldownSeconds > 0) {
      this.transferError = `Espera ${this.transferCooldownSeconds} segundos antes de hacer otra transferencia.`;
      return;
    }

    const amount = Number(this.transferAmount);
    const profileId = this.getTransferRecipientProfileId(this.selectedTransferRecipient);
    const currency = String(this.transferCurrency || 'MXN').trim().toUpperCase();

    this.transferMessage = '';
    this.transferError = '';

    if (!profileId) {
      this.transferError = 'Selecciona un usuario de Laniakea.';
      return;
    }

    if (!Number.isFinite(amount) || amount <= 0) {
      this.transferError = 'Ingresa un monto valido.';
      return;
    }

    const recipientName = this.getSelectedTransferRecipientName()
      || this.selectedTransferRecipient?.user_info?.username
      || 'otro usuario de Laniakea';

    this.pendingTransferConfirmation = {
      profileId,
      amount,
      currency,
      concept: String(this.transferConcept || '').trim(),
      recipientName,
      recipientUsername: this.getSelectedTransferRecipientUsername(),
      recipientPhotoUrl: this.getTransferRecipientPhotoUrl(this.selectedTransferRecipient),
      recipientVerified: this.isTransferRecipientVerified(this.selectedTransferRecipient),
    };
    this.transferConfirmationOpen = true;
    await this.lightHaptic();
  }

  public dismissTransferConfirmation(): void {
    if (this.transferLoading) {
      return;
    }

    this.transferConfirmationOpen = false;
    this.pendingTransferConfirmation = null;
  }

  public async confirmHubbleTransfer(): Promise<void> {
    const confirmation = this.pendingTransferConfirmation;
    if (!confirmation || this.transferLoading) {
      return;
    }

    this.transferLoading = true;
    await this.lightHaptic();

    try {
      const response = await this.request.createRequestPost('HubbleToHubbleTransfer', {
        profile_id: confirmation.profileId,
        amount: confirmation.amount,
        currency: confirmation.currency,
        concept: confirmation.concept,
      });
      const parsed = this.parseMaybeJson(response);

      if (parsed?.status !== 'success') {
        throw new Error(parsed?.message || 'No se pudo completar la transferencia.');
      }

      this.sendHubbleTransferNotifications(
        confirmation.amount,
        confirmation.currency,
        confirmation.profileId,
        confirmation.recipientName,
      );

      this.transferReceipt = {
        reference: this.getHubbleTransferReference(parsed),
        amount: confirmation.amount,
        currency: confirmation.currency,
        concept: confirmation.concept,
        recipientName: confirmation.recipientName,
        recipientUsername: confirmation.recipientUsername,
        recipientPhotoUrl: confirmation.recipientPhotoUrl,
        completedAt: new Date(),
      };
      this.transferReceiptCopyLabel = 'Copiar referencia';
      this.transferMessage = 'Transferencia Hubble completada.';
      this.transferAmount = null;
      this.transferConcept = '';
      this.transferRecipients = [];
      this.selectedTransferRecipient = null;
      this.transferSearchTerm = '';
      this.transferRecipientSource = 'manual';
      this.startTransferCooldown(30);
      await this.refreshHubbleData(true);
      await this.successHaptic();
    } catch (error) {
      console.error('Hubble transfer failed:', error);
	  this.socialNotifications.notifyLocal(
		'Pago no completado',
		'No fue posible completar la transferencia. Tu saldo no fue confirmado como debitado.',
		{ event_type: 'payment_failed', payment_method: 'Hubble' },
	  );
      const parsedError = this.parseMaybeJson(error?.error || error?.message || error);
      const retryAfter = Number(parsedError?.retry_after || error?.error?.retry_after || 0);
      if (retryAfter > 0) {
        this.startTransferCooldown(retryAfter);
      }
      this.transferError = parsedError?.message || parsedError?.error || 'No se pudo completar la transferencia.';
      await this.haptics.error();
    } finally {
      this.transferLoading = false;
      this.transferConfirmationOpen = false;
      this.pendingTransferConfirmation = null;
    }
  }

  private getTransferRecipientProfileId(recipient: any): number {
    return Number(recipient?.user_info?.profile_id || recipient?.profile_id || recipient?.id || 0);
  }

  public async copyHubbleTransferReference(): Promise<void> {
    if (!this.transferReceipt?.reference) return;

    try {
      await Clipboard.write({ string: this.transferReceipt.reference });
      this.transferReceiptCopyLabel = 'Referencia copiada';
      clearTimeout(this.transferReceiptCopyTimer);
      this.transferReceiptCopyTimer = setTimeout(() => {
        this.transferReceiptCopyLabel = 'Copiar referencia';
      }, 2200);
      await this.successHaptic();
    } catch (error) {
      console.error('[Hubble] Unable to copy transfer reference', error);
      this.transferError = 'No se pudo copiar la referencia.';
      await this.haptics.error();
    }
  }

  public async shareHubbleTransferReceipt(): Promise<void> {
    const receipt = this.transferReceipt;
    if (!receipt) return;

    const text = [
      'Comprobante Hubble Pay',
      `Enviaste ${receipt.amount.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${receipt.currency} a ${receipt.recipientName}.`,
      `Referencia: ${receipt.reference}`,
      receipt.concept ? `Concepto: ${receipt.concept}` : '',
    ].filter(Boolean).join('\n');

    try {
      if (Capacitor.getPlatform() !== 'web') {
        await Share.share({
          title: 'Comprobante Hubble Pay',
          text,
          dialogTitle: 'Compartir comprobante',
        });
        return;
      }

      if (navigator.share) {
        await navigator.share({ title: 'Comprobante Hubble Pay', text });
      } else {
        await this.copyHubbleTransferReference();
      }
    } catch (error) {
      console.error('[Hubble] Unable to share transfer receipt', error);
    }
  }

  private getHubbleTransferReference(response: any): string {
    const details = response?.data || response?.transfer || response || {};
    const value = details?.reference
      || details?.transaction_reference
      || details?.transaction_id
      || details?.transfer_id
      || details?.id;

    return value ? String(value) : `HUB-${Date.now().toString(36).toUpperCase()}`;
  }

  private sendHubbleTransferNotifications(
    amount: number,
    currency: string,
    recipientProfileId: number,
    recipientName: string,
  ): void {
    const senderTitle = 'Transferencia Hubble enviada';
    const senderBody = `Enviaste ${amount} ${currency} a ${recipientName}.`;

    if (Capacitor.getPlatform() !== 'web') {
      Promise.resolve(LocalNotifications.schedule({
        notifications: [{
          title: senderTitle,
          body: senderBody,
          id: Math.floor(Date.now() % 2147483647),
          schedule: { at: new Date(Date.now() + 250) },
          sound: null,
          attachments: null,
          actionTypeId: '',
          extra: {
            payout_method: 'Hubble',
            recipient_profile_id: recipientProfileId,
          },
          channelId: null,
        }],
      })).catch((error) => {
        console.error('Failed to schedule native Hubble notification:', error);
      });
    }

    const notifications = [
      {
        title: senderTitle,
        body: senderBody,
        profile_id: this.profile_id,
      },
      {
        title: 'Transferencia Hubble recibida',
        body: `Recibiste ${amount} ${currency} en tu cartera Hubble.`,
        profile_id: recipientProfileId,
      },
    ];

    notifications.forEach((notification) => {
      this.request.createRequestPost('GreatAtractorNotifications', notification)
        .catch((error) => {
          // Notification delivery must not change a completed transfer result.
          console.error('Failed to send Hubble transfer notification:', error);
        });
    });
  }

  public isPaymentPrefSectionLocked(section: string): boolean {
    return section === 'Payment Pref.' && !this.canAccessPaymentPreferences();
  }

  private canAccessPaymentPreferences(): boolean {
    return this.paymentPrefShortcutAllowed || this.isVerifiedUser();
  }

  public isVerifiedUser(): boolean {
    if (!this.profile) {
      return false;
    }

    return this.walletService.isKycVerified(this.profile?.kyc);
  }

  async openPremiumVerification(): Promise<void> {
    if (!this.profile) {
      Swal.fire({
        title: 'Inicia sesión',
        text: 'Necesitas iniciar sesión para activar Premium.',
        icon: 'info',
        timer: 4200,
        timerProgressBar: true,
        toast: true,
        position: 'top-start',
        showConfirmButton: false,
        background: '#010f4e',
        color: '#ffffff',
      });
      this.router.navigate(['/login']);
      return;
    }

    if (this.isVerifiedUser()) {
      Swal.fire({
        title: 'Premium activo',
        text: 'Tu perfil ya está verificado.',
        icon: 'success',
        timer: 3600,
        timerProgressBar: true,
        toast: true,
        position: 'top-start',
        showConfirmButton: false,
        background: '#010f4e',
        color: '#ffffff',
      });
      return;
    }

    const modal = await this.modalcontroller.create({
      component: PagoVerificacionComponent,
      cssClass: 'detailsInModal',
      canDismiss: true,
      componentProps: {
        pr: this.profile,
      },
    });
    await modal.present();
  }

  private hasExplicitCheckoutShortcut(): boolean {
    return this.shortcut === 'pagoDePublicacion' ||
      !!this.objmedia ||
      !!this.TotalPayment;
  }

  private hasTapToPaySettingsShortcut(): boolean {
    return this.route.snapshot.queryParamMap.get('source') === 'tap_to_pay_settings';
  }

  private showPaymentPreferencesVerificationAlert() {
    Swal.fire({
      title: 'Usuario no verificado',
      text: 'Completa la verificacion de tu cuenta para acceder a preferencias de pago desde la cartera.',
      icon: 'warning',
      timer: 3600,
      timerProgressBar: true,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      background: '#010f4e',
      color: '#ffffff'
    });
  }

	public closeConversionUI() {
		this.conversionActive = false;
		this.loyaltyCardsActive = false;
		this.selectedChain = null;
		this.selectedCoinGroup = null;
		this.conversionViewMode = 'coin';
		this.conversionesMXN = false;
		this.conversionesBTC = false;
		this.conversionesUSDT = false;
		this.conversionesETH = false;
		this.conversionesLTC = false;
		this.conversionesXRP = false;
		this.conversionesDOGE = false;
		this.conversionesSHIB = false;
		this.conversionesBNB = false;
		this.conversionesSOL = false;
		this.amount1 = 0;
		this.amount2 = 0;
		this.conversionGrossAmount = 0;
		this.conversionCommissionAmount = 0;
		this.currency1 = '';
			this.currency2 = '';
			const w = document.getElementById('tradingview-widget');
			if (w) { w.innerHTML = ''; }
			this.schedulePortfolioGlobalChartRefresh();
		}

	public closeLoyaltyCardsUI() {
		this.loyaltyCardsActive = false;
		this.schedulePortfolioGlobalChartRefresh();
	}

	public async openLoyaltyCardsUI() {
		this.conversionActive = false;
		this.loyaltyCardsActive = true;
		this.destroyPortfolioGlobalChart();
		await this.loadLoyaltyCards();
	}

	public async loadLoyaltyCards() {
		if (this.loyaltyCardsLoading) {
			return;
		}
		this.loyaltyCardsLoading = true;
		this.loyaltyCardsError = '';

		try {
			const response = await this.request.createRequestGet('loyalty-cards');
			const data = this.parseApiResponse(response);
			this.loyaltyCards = Array.isArray(data?.cards) ? data.cards : [];
		} catch (error) {
			console.error('[Hubble] Loyalty cards failed:', error);
			this.loyaltyCardsError = 'No se pudieron cargar las tarjetas de fidelidad.';
		} finally {
			this.loyaltyCardsLoading = false;
		}
	}

	public async createLoyaltyCard() {
		if (this.loyaltyCardsLoading) {
			return;
		}
		this.loyaltyCardsLoading = true;
		this.loyaltyCardsError = '';
		this.generatedLoyaltyClaimUrl = '';
		this.generatedLoyaltyQrUrl = '';
		this.generatedLoyaltyCard = null;

		try {
			const response = await this.request.createRequestPost('loyalty-cards', this.buildLoyaltyCardPayload());
			const data = this.parseApiResponse(response);
			if (data?.card) {
				this.loyaltyCards = [data.card, ...this.loyaltyCards];
				this.generatedLoyaltyCard = data.card;
				await this.showLoyaltyClaimQr(data.card);
				this.resetLoyaltyCardDraft();
			} else {
				await this.loadLoyaltyCards();
			}
		} catch (error) {
			console.error('[Hubble] Loyalty card creation failed:', error);
			this.loyaltyCardsError = 'No se pudo generar la tarjeta de fidelidad.';
		} finally {
			this.loyaltyCardsLoading = false;
		}
	}

	private async lightHaptic(): Promise<void> {
		await this.haptics.action();
	}

	private async successHaptic(): Promise<void> {
		await this.haptics.success();
	}

	public getLastHubbleRefreshLabel(): string {
		if (!this.lastHubbleRefreshAt) {
			return 'Actualizando datos';
		}

		const seconds = Math.max(0, Math.floor((Date.now() - this.lastHubbleRefreshAt.getTime()) / 1000));
		if (seconds < 60) {
			return `Actualizado hace ${seconds || 1}s`;
		}

		const minutes = Math.floor(seconds / 60);
		return `Actualizado hace ${minutes}m`;
	}

	public getLoyaltyCardStatus(card: any): string {
		return card?.claimed_at ? 'Agregada a Wallet' : 'QR disponible';
	}

	public async copyGeneratedLoyaltyClaimUrl(): Promise<void> {
		if (!this.generatedLoyaltyClaimUrl) {
			return;
		}

		try {
			await navigator.clipboard?.writeText(this.generatedLoyaltyClaimUrl);
			this.loyaltyCardsError = '';
		} catch (error) {
			console.error('[Hubble] Copy loyalty claim URL failed:', error);
			this.loyaltyCardsError = 'No se pudo copiar el enlace del QR.';
		}
	}

	public async shareGeneratedLoyaltyClaimUrl(): Promise<void> {
		if (!this.generatedLoyaltyClaimUrl) {
			return;
		}

		try {
			if (Capacitor.getPlatform() !== 'web') {
				await Share.share({
					title: 'Apple Wallet',
					text: 'Escanea o abre este enlace para agregar la tarjeta.',
					url: this.generatedLoyaltyClaimUrl,
					dialogTitle: 'Compartir QR Apple Wallet',
				});
				return;
			}

			if (navigator.share) {
				await navigator.share({
					title: 'Apple Wallet',
					text: 'Escanea o abre este enlace para agregar la tarjeta.',
					url: this.generatedLoyaltyClaimUrl,
				});
			} else {
				await this.copyGeneratedLoyaltyClaimUrl();
			}
		} catch (error) {
			console.error('[Hubble] Share loyalty claim URL failed:', error);
			this.loyaltyCardsError = 'No se pudo compartir el enlace del QR.';
		}
	}

	public async notifyLoyaltyCard(card: any, ev?: Event) {
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}

		if (!card?.id) {
			this.loyaltyCardsError = 'La tarjeta no se puede actualizar todavia.';
			return;
		}

		const result = await Swal.fire({
			title: 'Actualizar Apple Wallet',
			html: `
				<input id="walletOfferMessage" class="swal2-input" maxlength="160" placeholder="Mensaje visible" value="${this.escapeSwalValue(card.offer_message || '')}">
				<input id="walletChangeMessage" class="swal2-input" maxlength="160" placeholder="Notificacion, usa %@ para el valor" value="${this.escapeSwalValue(card.change_message || 'Tu tarjeta se actualizo: %@')}">
				<input id="walletMoneyAmount" class="swal2-input" type="number" min="0" step="0.01" placeholder="Saldo" value="${Number(card.money_amount || 0)}">
				<input id="walletStars" class="swal2-input" type="number" min="0" max="10" step="1" placeholder="Estrellas" value="${Number(card.stars || 0)}">
			`,
			background: '#061039',
			color: '#ffffff',
			confirmButtonText: 'Enviar',
			cancelButtonText: 'Cancelar',
			showCancelButton: true,
			focusConfirm: false,
			preConfirm: () => {
				const offerMessage = (document.getElementById('walletOfferMessage') as HTMLInputElement)?.value || '';
				const changeMessage = (document.getElementById('walletChangeMessage') as HTMLInputElement)?.value || 'Tu tarjeta se actualizo: %@';
				const moneyAmount = Number((document.getElementById('walletMoneyAmount') as HTMLInputElement)?.value || 0);
				const stars = Number((document.getElementById('walletStars') as HTMLInputElement)?.value || 0);
				return {
					offer_message: offerMessage.trim(),
					change_message: changeMessage.trim(),
					money_amount: Math.max(0, moneyAmount),
					stars: Math.max(0, Math.min(10, Math.round(stars))),
				};
			}
		});

		if (!result.isConfirmed || !result.value) {
			return;
		}

		this.loyaltyCardsLoading = true;
		this.loyaltyCardsError = '';

		try {
			const response = await this.request.createRequestPost('loyalty-cards', result.value, { id: card.id }, 'notify');
			const data = this.parseApiResponse(response);
			if (data?.card) {
				this.loyaltyCards = this.loyaltyCards.map((item) => Number(item.id) === Number(card.id) ? data.card : item);
				if (this.generatedLoyaltyCard && Number(this.generatedLoyaltyCard.id) === Number(card.id)) {
					this.generatedLoyaltyCard = data.card;
				}
			}

			await Swal.fire({
				title: 'Wallet actualizada',
				text: data?.push?.sent ? 'Apple Wallet recibira la actualizacion.' : 'La tarjeta se actualizo; aun no hay dispositivos registrados para push.',
				icon: 'success',
				toast: true,
				timer: 2600,
				position: 'top',
				showConfirmButton: false,
				background: '#061039',
				color: '#ffffff',
			});
		} catch (error) {
			console.error('[Hubble] Loyalty card notification failed:', error);
			this.loyaltyCardsError = 'No se pudo enviar la actualizacion a Apple Wallet.';
		} finally {
			this.loyaltyCardsLoading = false;
		}
	}

	private escapeSwalValue(value: any): string {
		return String(value || '')
			.replace(/&/g, '&amp;')
			.replace(/"/g, '&quot;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;');
	}

	private async showLoyaltyClaimQr(card: any) {
		if (!card?.apple_wallet_claim_url) {
			throw new Error('Apple Wallet claim URL is missing.');
		}

		this.generatedLoyaltyClaimUrl = card.apple_wallet_claim_url;
		this.generatedLoyaltyQrUrl = await QRCode.toDataURL(card.apple_wallet_claim_url, {
			margin: 1,
			width: 260,
			errorCorrectionLevel: 'M',
		});
	}

	public async showExistingLoyaltyClaimQr(card: any, ev?: Event) {
		this.lightHaptic();
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}

		if (card?.claimed_at) {
			this.loyaltyCardsError = 'Este QR ya fue utilizado.';
			return;
		}

		try {
			this.loyaltyCardsError = '';
			this.generatedLoyaltyCard = card;
			await this.showLoyaltyClaimQr(card);
		} catch (error) {
			console.error('[Hubble] Loyalty claim QR failed:', error);
			this.loyaltyCardsError = 'No se pudo mostrar el QR de la tarjeta.';
		}
	}

	private resetLoyaltyCardDraft() {
		this.loyaltyCardDraft = {
			store_name: '',
			card_name: '',
			member_name: '',
			brand_image_url: '',
			notification_icon_url: '',
			money_amount: 0,
			currency_code: 'MXN',
			offer_message: '',
			change_message: 'Tu tarjeta se actualizó: %@',
			background_color: '#050a2f',
		};
	}

	private buildLoyaltyCardPayload() {
		const draft = this.loyaltyCardDraft || {};
		return {
			store_name: this.cleanLoyaltyText(draft.store_name, 'Laniakea Rewards'),
			card_name: this.cleanLoyaltyText(draft.card_name, draft.store_name || 'Rewards Pass'),
			member_name: this.cleanLoyaltyText(draft.member_name, 'Cliente Laniakea'),
			brand_image_url: this.cleanLoyaltyText(draft.brand_image_url, ''),
			notification_icon_url: this.cleanLoyaltyText(draft.notification_icon_url, ''),
			money_amount: Math.max(0, Number(draft.money_amount || 0)),
			currency_code: this.cleanCurrencyCode(draft.currency_code),
			offer_message: this.cleanLoyaltyText(draft.offer_message, ''),
			change_message: this.cleanLoyaltyText(draft.change_message, 'Tu tarjeta se actualizó: %@'),
			background_color: this.cleanLoyaltyText(draft.background_color, '#050a2f'),
		};
	}

	private cleanLoyaltyText(value: any, fallback: string): string {
		const text = String(value || '').trim();
		return text || fallback;
	}

	private cleanCurrencyCode(value: any): string {
		const currency = String(value || 'MXN').trim().toUpperCase();
		return /^[A-Z]{3}$/.test(currency) ? currency : 'MXN';
	}

	public getLoyaltyStars(card: any): number[] {
		const stars = Math.max(0, Math.min(10, Number(card?.stars || 0)));
		return Array.from({ length: Math.max(5, stars || 5) }, (_, index) => index);
	}

	public isLoyaltyStarActive(card: any, index: number): boolean {
		return index < Number(card?.stars || 0);
	}

	public async downloadAppleWalletPass(card: any, ev?: Event) {
		this.lightHaptic();
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}

		if (!card?.id) {
			this.loyaltyCardsError = 'La tarjeta aun no tiene URL de Apple Wallet.';
			return;
		}

		try {
			this.loyaltyCardsError = '';
			const response = await this.request.createRequestGet(
				'loyalty-cards',
				null,
				{ id: card.id },
				'apple-wallet-pass'
			);
			const payload = this.parseApiResponse(response);
			if (!payload?.pkpass_base64) {
				throw new Error('Apple Wallet pass response is missing pkpass_base64.');
			}

			await this.openAppleWalletPass(
				payload.pkpass_base64,
				payload.mime_type || 'application/vnd.apple.pkpass',
				payload.filename || `laniakea_rewards_${card.id}.pkpass`
			);
		} catch (error) {
			console.error('[Hubble] Apple Wallet pass download failed:', error);
			this.loyaltyCardsError = 'No se pudo abrir la tarjeta de Apple Wallet. Revisa certificados/configuracion del pass.';
		}
	}

	private async openAppleWalletPass(base64: string, contentType: string, filename: string) {
		if (Capacitor.getPlatform() === 'ios') {
			await AppleWallet.addPass({ base64 });
			return;
		}

		if (Capacitor.getPlatform() !== 'web') {
			const safeFilename = this.sanitizePkpassFilename(filename);
			const savedFile = await Filesystem.writeFile({
				path: safeFilename,
				data: base64,
				directory: Directory.Cache,
				recursive: true,
			});

			await Share.share({
				title: 'Apple Wallet',
				text: 'Agregar tarjeta a Apple Wallet',
				url: savedFile.uri,
				dialogTitle: 'Apple Wallet',
			});
			return;
		}

		const blob = this.base64ToBlob(base64, contentType);
		const url = URL.createObjectURL(blob);
		window.open(url, '_blank');
		setTimeout(() => URL.revokeObjectURL(url), 60000);
	}

	private sanitizePkpassFilename(filename: string): string {
		const safe = String(filename || 'laniakea_rewards.pkpass')
			.replace(/[^A-Za-z0-9._-]/g, '_')
			.replace(/_+/g, '_');

		return safe.endsWith('.pkpass') ? safe : `${safe}.pkpass`;
	}

	private base64ToBlob(base64: string, contentType: string): Blob {
		const binary = atob(base64);
		const bytes = new Uint8Array(binary.length);

		for (let index = 0; index < binary.length; index++) {
			bytes[index] = binary.charCodeAt(index);
		}

		return new Blob([bytes], { type: contentType });
	}

	private parseApiResponse(response: any): any {
		if (typeof response === 'string') {
			try {
				return JSON.parse(response);
			} catch {
				return {};
			}
		}

		return response || {};
	}

	/**
	 * Public method to refresh Hubble wallet data (balances + transactions) on demand.
	 * Can be called from child components (e.g. when clicking "Ver Balance").
	 */
	public async refreshHubbleData(force: boolean = true) {
		if (!this.profile_id) {
			return;
		}

		if (this.isGlobalBalanceRefreshing) {
			return;
		}

		// Allow force refresh even if recently fetched
		if (!force && this.HubbleExpired) {
			return;
		}

		this.isGlobalBalanceRefreshing = true;
		this.isLaniakeaBalanceLoading = true;
		this.lightHaptic();

		try {
			await this.fetchHubbleWalletData();
			this.lastHubbleRefreshAt = new Date();
			// After getting fresh balances, re-fetch rates so global summatory is accurate
			this.retrieveBalanceRateMXN();
		} finally {
			// The loader will be hidden once calculateGlobalBalance finishes and data is bound
			setTimeout(() => {
				this.isGlobalBalanceRefreshing = false;
			}, 300); // small delay so animation is visible
		}
	}

	/**
	 * Global refresh that works from any tab.
	 * Refreshes balances + rates + recalculates the global summatory.
	 */
	public async refreshAllWalletData() {
		if (this.isGlobalBalanceRefreshing) {
			return;
		}
		await this.refreshHubbleData(true);
		// Force rate refresh + recalculation
		this.retrieveBalanceRateMXN();
	}

	/**
	 * Eye click handler for the new Hubble design eyebar.
	 * Toggles global hideBalance for the chain list (masked vs visible values)
	 * and refreshes data (matching original handleEyeClick + per-currency behavior intent).
	 */
		public handleEyeClick() {
			this.hideBalance = !this.hideBalance;
			const shouldRevealBalance = this.hideBalance;
			const laniakeaBalanceIsZero = Number(this.LaniakeaBalance || 0) === 0;
			if(shouldRevealBalance && laniakeaBalanceIsZero && this.isVerifiedUser()){
				this.refreshHubbleData(true);
			}
			this.schedulePortfolioGlobalChartRefresh();
			
		}

	/**
	 * Dedicated refresh for the eyebar refresh icon (separate from eye).
	 */
		public refreshEyebar() {
			this.destroyPortfolioGlobalChart();
			this.refreshHubbleData(true);
		}

	back() {
		// When wallet-app is opened as a modal (e.g. for product purchase / pagoDePublicacion / alibaba checkout),
		// the back button must close the modal controller instead of (or in addition to) navigating.
		// Try dismiss first; if no modal (or already standalone), fall back to navigation.
		this.modalcontroller.dismiss({ dismissed: true }).then((dismissed) => {
      if (!dismissed) {
        this.navigateBackFromWallet();
      }
    }).catch(() => {
      this.navigateBackFromWallet();
		});
	}

  private navigateBackFromWallet() {
    if (this.isStandalonePage) {
      this.router.navigate(['/home/ecosystem-page']);
    } else {
      this.router.navigate(['/home']);
    }
  }

  backToHome() {
    this.router.navigate(['/home']);
  }
		ngOnChanges(changes: SimpleChanges) {
	    if (changes['shortcut'] || changes['objmedia'] || changes['TotalPayment']) {
	      this.paymentPrefShortcutAllowed = this.paymentPrefShortcutAllowed || this.hasExplicitCheckoutShortcut();
	    }
	    if (changes['balances']) {
	      this.schedulePortfolioGlobalChartRefresh();
	    }
			
		}

		ngOnDestroy() {
			this.checkoutRouteSubscription?.unsubscribe();
			clearTimeout(this.transferReceiptCopyTimer);
			this.portfolioGlobalChartRequestId++;
			this.destroyPortfolioGlobalChart();
		}

	  public onBalanceUniversalChange(balanceUniversal: number): void {
		console.log('BalanceUniversal value:', balanceUniversal);
		this.LaniakeaBalance = balanceUniversal;
	  }
	

	  
	  
	
	

	ionViewWillEnter() {

		this.profile_service.getProfileInfo(this.profile_id).then((profileInfo)=>{
			profileInfo = JSON.parse(profileInfo);
			this.profile =profileInfo;
			this.profile_id = profileInfo.id;
		}).catch((error)=>{
			console.error(error);
		}).finally(()=>{

		});

	}



	reloadProfile(){
		this.profile_service.getProfileInfo(this.profile_id).then((data)=>{
			data = JSON.parse(data);

			this.profile = data;
			this.profile_id = data.id;
		}).catch((error)=>{
			console.error(error);
		}).finally(()=>{

		});
	}

	// ===== Restored "click specific currency item opens cool UI" feature =====
	// The hubble rows are now clickable. Clicking opens the conversion/swap form + TradingView chart
	// (the "cool ui" that was in the original my-wallet list rows).
	// The UI is embedded inside the hubble-blockchains so the new design list graphics are used for the
	// balance view, and the cool ui replaces the list when active (with close to return).
	// Logic ported/adapted from my-wallet (with support for all 8 rows incl. BNB/SOL/SHIB).

	public onChainClick(chain: any) {
		if (chain.id === 'd') {
			return;
		}

		if (chain.isLoyalty || chain.id === 'loyalty-cards') {
			this.openLoyaltyCardsUI();
			return;
		}

		if (chain.isCoinGroup) {
			this.selectedCoinGroup = chain;
			return;
		}

		if (chain.id === 'mxn') {
			// For the MXN item only: the whole row click acts as the "depositar MXN" shortcut
			// (bank-style "ver cuenta y CLABE"). Navigates to Payment Pref and calls methodChange
			// to auto-select SPEI + scroll to bottom of the UI.
			this.goToSpeiAccount();
			return;
		}
		this.conversionActive = true;
		this.conversionViewMode = 'coin';
		this.selectedChain = chain;
		this.currency2 = chain.unit || 'USDT.ERC20';
		this.currency1 = 'USDT.ERC20';
		this.loadGenericChart(chain);
	}

	public closeCoinGroupDetails(ev?: Event) {
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}
		this.selectedCoinGroup = null;
	}

	public onChainNetworkClick(chain: any, ev?: Event) {
		if (ev) {
			ev.stopPropagation();
		}
		this.selectedCoinGroup = null;
		this.onChainClick(chain);
	}

	public openSelectedChainTrade(ev?: Event) {
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}
		if (!this.selectedChain) {
			return;
		}
		this.conversionViewMode = 'trade';
		const chain = this.selectedChain;
		switch (chain.id) {
			case 'btc': this.clickbtc(); break;
			case 'eth': this.clicketh(); break;
			case 'bnb': this.clickbnb(); break;
			case 'ltc': this.clickltc(); break;
			case 'usdt': this.clickusdt(); break;
			case 'sol': this.clicksol(); break;
			case 'shib': this.clickshib(); break;
			default:
				this.currency2 = chain.unit || 'USDT.ERC20';
				this.currency1 = 'USDT.ERC20';
				this.loadGenericChart(chain);
		}
	}

	public sendSelectedChain(ev?: Event, chain?: any) {
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}
		const targetChain = chain || this.selectedChain;
		if (!targetChain) {
			return;
		}
		if (this.isMxnChain(targetChain)) {
			void this.openSpeiWithdrawal();
			return;
		}
		this.shortcut = `coinpayment-withdraw:${targetChain.unit}:${Date.now()}`;
		this.section_change('Payouts');
	}

	public receiveSelectedChain(ev?: Event, chain?: any) {
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}
		const targetChain = chain || this.selectedChain;
		if (!targetChain) {
			return;
		}
		if (this.isMxnChain(targetChain)) {
			this.goToSpeiAccount();
			return;
		}
		if (!this.canAccessPaymentPreferences()) {
			this.showPaymentPreferencesVerificationAlert();
			return;
		}
		this.beginWalletPaymentPreference(`coinpayment:${targetChain.unit}:${Date.now()}`);
	}

	private isMxnChain(chain: any): boolean {
		return String(chain?.unit || '').trim().toUpperCase() === 'MXN';
	}

	/** Opens the existing SPEI payout form used by the Payouts section. */
	public async openSpeiWithdrawal(): Promise<void> {
		if (!this.profile_id) {
			Swal.fire({
				title: 'Inicia sesión',
				text: 'Necesitas iniciar sesión para enviar dinero por SPEI.',
				icon: 'info',
				toast: true,
				position: 'top-end',
				showConfirmButton: false,
				timer: 2600,
				background: '#010f4e',
				color: '#ffffff'
			});
			return;
		}

		const modal = await this.modalcontroller.create({
			component: RetirosPaypalComponent,
			cssClass: 'detailsInModal',
			canDismiss: true,
			componentProps: {
				profile_id: this.profile_id,
				CLABE: true,
				Interbank: true,
				paymentEndpoint: 'make_a_bbva_api_channel_business_payment',
				paymentIdentifier: 'spei',
				balances: this.balances,
				balance: this.balances?.[0]?.currency_1 ?? null,
				isRefreshing: this.isGlobalBalanceRefreshing
			}
		});

		modal.onDidDismiss().then(() => this.refreshHubbleData());
		await modal.present();
	}

	public getSelectedChainPortfolioPercentage(): number {
		if (!this.selectedChain || !this.LaniakeaBalance) {
			return 0;
		}
		const value = this.getMxnValue(this.selectedChain);
		return Math.max(0, Math.min(100, (value / this.LaniakeaBalance) * 100));
	}

	public getSelectedChainPriceMxn(): number {
		if (!this.selectedChain) {
			return 0;
		}
		const nativeBalance = this.getNativeBalance(this.selectedChain);
		const mxnValue = this.getMxnValue(this.selectedChain);
		return nativeBalance > 0 ? (mxnValue / nativeBalance) : 0;
	}

	// Shortcut for MXN balance: acts as "Ver cuenta y CLABE" like in a bank app.
	// Navigates to Payment Pref segment and auto-selects the SPEI method so user can view
	// their Laniakea account details (CLABE, Agreement, Name/Concepto) for receiving MXN via SPEI.
	public goToSpeiAccount(ev?: Event) {
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}
    if (!this.canAccessPaymentPreferences()) {
      this.showPaymentPreferencesVerificationAlert();
      return;
    }
		this.beginWalletPaymentPreference('spei');
	}

	// --- click handlers and loaders (adapted from original, including new coins) ---
	clickmxn(){
		this.currency1 = "USDT.ERC20";
		this.mxn();
	}
	mxn(){
		this.conversionesBTC = true;
		this.conversionesUSDT = true;
		this.conversionesETH = true;
		this.conversionesLTC = true;
		this.conversionesXRP = true;
		this.conversionesDOGE = true;
		this.conversionesSHIB = true;
		this.conversionesBNB = true;
		this.conversionesSOL = true;
		this.conversionActive = true;
		this.symbol = 'FOREXCOM:USDMXN';
		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/tv.js';
		script.async = true;
		script.onload = this.initializeChart.bind(this);
		document.head.appendChild(script);
	}

	clickbtc(){
		this.currency1 = "DOGE";
		this.currency2 = "USDT.ERC20";
		this.btc();
	}
	btc(){
		this.conversionesMXN = true;
		this.conversionesUSDT = true;
		this.conversionesETH = true;
		this.conversionesLTC = true;
		this.conversionesXRP = true;
		this.conversionesDOGE = true;
		this.conversionesSHIB = true;
		this.conversionesBNB = true;
		this.conversionesSOL = true;
		this.conversionActive = true;
		this.symbol = 'BINANCE:BTCUSDT';
		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/tv.js';
		script.async = true;
		script.onload = this.initializeChart.bind(this);
		document.head.appendChild(script);
	}

	clickusdt(){
		this.currency1 = "MXN";
		this.currency2 = "USDT.ERC20";
		this.usdt();
	}
	usdt(){
		this.conversionesMXN = true;
		this.conversionesBTC = true;
		this.conversionesETH = true;
		this.conversionesLTC = true;
		this.conversionesXRP = true;
		this.conversionesDOGE = true;
		this.conversionesSHIB = true;
		this.conversionesBNB = true;
		this.conversionesSOL = true;
		this.conversionActive = true;
		this.symbol = 'FX_IDC:MXNUSD';
		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/tv.js';
		script.async = true;
		script.onload = this.initializeChart.bind(this);
		document.head.appendChild(script);
	}

	clicketh(){
		this.currency1 = "ETH";
		this.currency2 = "USDT.ERC20";
		this.eth();
	}
	eth(){
		this.conversionesMXN = true;
		this.conversionesBTC = true;
		this.conversionesUSDT = true;
		this.conversionesLTC = true;
		this.conversionesXRP = true;
		this.conversionesDOGE = true;
		this.conversionesSHIB = true;
		this.conversionesBNB = true;
		this.conversionesSOL = true;
		this.conversionActive = true;
		this.symbol = 'COINBASE:ETHUSD';
		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/tv.js';
		script.async = true;
		script.onload = this.initializeChart.bind(this);
		document.head.appendChild(script);
	}

	clickltc(){
		this.currency1 = "LTC";
		this.currency2 = "USDT.ERC20";
		this.ltc();
	}
	ltc(){
		this.conversionesMXN = true;
		this.conversionesBTC = true;
		this.conversionesUSDT = true;
		this.conversionesETH = true;
		this.conversionesXRP = true;
		this.conversionesDOGE = true;
		this.conversionesSHIB = true;
		this.conversionesBNB = true;
		this.conversionesSOL = true;
		this.conversionActive = true;
		this.symbol = 'KRAKEN:LTCUSD';
		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/tv.js';
		script.async = true;
		script.onload = this.initializeChart.bind(this);
		document.head.appendChild(script);
	}

	clickxrp(){
		this.currency1 = "XRP";
		this.currency2 = "USDT.ERC20";
		this.xrp();
	}
	xrp(){
		this.conversionesMXN = true;
		this.conversionesBTC = true;
		this.conversionesUSDT = true;
		this.conversionesETH = true;
		this.conversionesLTC = true;
		this.conversionesDOGE = true;
		this.conversionesSHIB = true;
		this.conversionesBNB = true;
		this.conversionesSOL = true;
		this.conversionActive = true;
		this.symbol = 'BINANCE:XRPUSD';
		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/tv.js';
		script.async = true;
		script.onload = this.initializeChart.bind(this);
		document.head.appendChild(script);
	}

	clickshib(){
		this.currency1 = "SHIB";
		this.currency2 = "USDT.ERC20";
		this.shib();
	}
	shib(){
		this.conversionesMXN = true;
		this.conversionesBTC = true;
		this.conversionesUSDT = true;
		this.conversionesETH = true;
		this.conversionesLTC = true;
		this.conversionesXRP = true;
		this.conversionesDOGE = true;
		this.conversionesSHIB = true;
		this.conversionesBNB = true;
		this.conversionesSOL = true;
		this.conversionActive = true;
		this.symbol = 'KUCOIN:SHIBUSDT';
		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/tv.js';
		script.async = true;
		script.onload = this.initializeChart.bind(this);
		document.head.appendChild(script);
	}

	// Support for BNB/SOL rows (in addition to the original coins) in the conversion UI
	clickbnb(){
		this.currency1 = "BNB";
		this.currency2 = "USDT.ERC20";
		this.bnb();
	}
	bnb(){
		this.conversionesMXN = true;
		this.conversionesBTC = true;
		this.conversionesUSDT = true;
		this.conversionesETH = true;
		this.conversionesLTC = true;
		this.conversionesXRP = true;
		this.conversionesDOGE = true;
		this.conversionesSHIB = true;
		this.conversionesBNB = true;
		this.conversionesSOL = true;
		this.conversionActive = true;
		this.symbol = 'BINANCE:BNBUSDT';
		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/tv.js';
		script.async = true;
		script.onload = this.initializeChart.bind(this);
		document.head.appendChild(script);
	}

	clicksol(){
		this.currency1 = "SOL";
		this.currency2 = "USDT.ERC20";
		this.sol();
	}
	sol(){
		this.conversionesMXN = true;
		this.conversionesBTC = true;
		this.conversionesUSDT = true;
		this.conversionesETH = true;
		this.conversionesLTC = true;
		this.conversionesXRP = true;
		this.conversionesDOGE = true;
		this.conversionesSHIB = true;
		this.conversionesBNB = true;
		this.conversionesSOL = true;
		this.conversionActive = true;
		this.symbol = 'BINANCE:SOLUSDT';
		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/tv.js';
		script.async = true;
		script.onload = this.initializeChart.bind(this);
		document.head.appendChild(script);
	}

	doge(){
		this.conversionesMXN = true;
		this.conversionesBTC = true;
		this.conversionesUSDT = true;
		this.conversionesETH = true;
		this.conversionesLTC = true;
		this.conversionesXRP = true;
		this.conversionesDOGE = true;
		this.conversionesSHIB = true;
		this.conversionesBNB = true;
		this.conversionesSOL = true;
		this.conversionActive = true;
		this.symbol = 'BINANCE:DOGEUSDT';
		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/tv.js';
		script.async = true;
		script.onload = this.initializeChart.bind(this);
		document.head.appendChild(script);
	}

	private loadGenericChart(chain: any) {
		this.symbol = this.getTradingViewSymbol(chain?.unit || 'BTC');
		this.loadTradingViewWidget();
	}

	private getTradingViewSymbol(currency: string): string {
		const normalizedCurrency = (currency || 'BTC').toUpperCase();
		const symbolMap: Record<string, string> = {
			BTC: 'BINANCE:BTCUSDT',
			ETH: 'COINBASE:ETHUSD',
			DOGE: 'BINANCE:DOGEUSDT',
			USDT: 'FX_IDC:MXNUSD',
			'USDT.ERC20': 'FX_IDC:MXNUSD',
			XRP: 'BINANCE:XRPUSDT',
			BNB: 'BINANCE:BNBUSDT',
			SOL: 'BINANCE:SOLUSDT',
			TRX: 'BINANCE:TRXUSDT',
			SHIB: 'KUCOIN:SHIBUSDT',
			BCH: 'BINANCE:BCHUSDT',
			DAI: 'FX_IDC:MXNUSD',
			AVAX: 'BINANCE:AVAXUSDT',
			POL: 'COINBASE:POLUSD',
			DASH: 'BINANCE:DASHUSDT',
			XMR: 'KRAKEN:XMRUSD',
			USDC: 'FX_IDC:MXNUSD',
			'PYUSD.ERC20': 'FX_IDC:MXNUSD',
			PAXG: 'BINANCE:PAXGUSDT',
			LINK: 'BINANCE:LINKUSDT',
			'DOT.BEP20': 'BINANCE:DOTUSDT',
			QTUM: 'BINANCE:QTUMUSDT',
			RVN: 'BINANCE:RVNUSDT',
		};

		return symbolMap[normalizedCurrency] || `BINANCE:${normalizedCurrency.replace(/[^A-Z0-9]/g, '')}USDT`;
	}

	private loadTradingViewWidget() {
		if (typeof TradingView !== 'undefined') {
			setTimeout(() => this.initializeChart(), 0);
			return;
		}

		const script = document.createElement('script');
		script.src = 'https://s3.tradingview.com/tv.js';
		script.async = true;
		script.onload = this.initializeChart.bind(this);
		document.head.appendChild(script);
	}

	initializeChart() {
		const container = document.getElementById('tradingview-widget');
		if (container) { container.innerHTML = ''; }
		const chartHeight = container?.clientHeight || Math.round(window.innerHeight * 0.63);
		new TradingView.widget({
			width: '100%',
			height: chartHeight,
			symbol: this.symbol,
			interval: '1',
			timezone: 'Etc/UTC',
			theme: 'dark',
			backgroundColor: "rgba(6, 13, 53, 0.95)",
			gridColor: "rgba(100, 130, 220, 0.2)",
			style: '1',
			locale: 'es',
			toolbar_bg: '#0a122f',
			enable_publishing: false,
			hide_side_toolbar: false,
			container_id: 'tradingview-widget'
		});
	}

	getCurrencyImageSrc(currency: string): string {
		if (currency === 'MXN') {
			return 'assets/divisas/logos/currency-4.png';
		}
		return this.getChainCurrencyImageSrc(currency);
	}

	public getCurrencyChain(currency: string): any {
		return this.hubbleChains.find((chain) => chain.unit === currency) || null;
	}

	public setAmount1(event: any) {
		this.amount1 = event;
		this.amount2 = 0;
		this.conversionGrossAmount = 0;
		this.conversionCommissionAmount = 0;
		if (!this.amount1 || !this.currency1 || !this.currency2) {
			return;
		}
		const object = { currency: this.currency1, amount: this.amount1, currency2: this.currency2 };
		this.walletService.getExchangeValue(object).then((data: any) => {
			this.amount2 = data.amount;
			this.conversionGrossAmount = Number(data.gross_amount || 0);
			this.conversionCommissionAmount = Number(data.commission_amount || 0);
		}).catch((error: any) => { console.error(error); });
	}

	getcurrency1(event: any) {
		this.walletService.currency = this.currency1;
		this.walletService.amount = this.amount1;
	}

	getcurrency2(event: any) {
		this.conversionesMXN = this.conversionesBTC = this.conversionesUSDT = this.conversionesETH =
		this.conversionesLTC = this.conversionesXRP = this.conversionesDOGE = this.conversionesSHIB =
		this.conversionesBNB = this.conversionesSOL = false;
		this.walletService.currency = this.currency2;
		this.walletService.amount = this.amount2;
		switch (this.currency2) {
			case 'DOGE': this.doge(); break;
			case 'MXN': this.mxn(); break;
			case 'BTC': this.btc(); break;
			case 'USDT':
			case 'USDT.ERC20': this.usdt(); break;
			case 'ETH': this.eth(); break;
			case 'LTC': this.ltc(); break;
			case 'XRP': this.xrp(); break;
			case 'SHIB': this.shib(); break;
			case 'BNB': this.bnb(); break;
			case 'SOL': this.sol(); break;
			default:
				this.symbol = this.getTradingViewSymbol(this.currency2);
				this.loadTradingViewWidget();
				break;
		}
		this.loadTradingViewWidget();
	}

	exchangeAssets(){
		const object = {
			currency1: this.currency1 === 'MXN' ? 'USDT.ERC20' : this.currency1,
			amount: this.amount1,
			currency2: this.currency2 === 'MXN' ? 'USDT.ERC20' : this.currency2,
			profile_id: this.profile_id
		};
		if (object.currency1 === object.currency2) {
			Swal.fire({ title: 'Warning', text: 'Trueque de activos no disponible, busca otro par.', icon: 'warning', confirmButtonText: 'OK', color: '#ffffff', background: '#010f4e', position: 'top-end', timerProgressBar: true, toast: true });
		} else {
			return new Promise((resolve, reject)=>{
				this.request.createRequestPost('exchangeAssets', object).then((data: any)=>{
					const response = typeof data === 'string' ? JSON.parse(data) : data;
					resolve(response);
					const receivedAmount = Number(response.destination_net_amount || this.amount2);
					Swal.fire({ title: 'Trueque enviado', text: `Recibirás ${receivedAmount} ${this.currency1} después de la confirmación de CoinPayments. La comisión de Laniakea (3%) ya está incluida.`, icon: 'success', confirmButtonText: 'Entendido', color: '#ffffff', background: '#010f4e', position: 'top-end', timerProgressBar: true, toast: true });
				}).catch((error: any)=>{ reject(error); });
			});
		}
	}

	conversion() {
		let minAmount = 0;
		switch (this.currency2) {
			case 'MXN': minAmount = 2100; break;
			case 'BTC': minAmount = 0.0042; break;
			case 'USDT':
			case 'USDT.ERC20': minAmount = 120; break;
			case 'ETH': minAmount = 0.063; break;
			case 'DOGE': minAmount = 1862; break;
			case 'XRP': minAmount = 252; break;
			case 'LTC': minAmount = 1.37; break;
			case 'SHIB': minAmount = 16000000; break;
			case 'BNB': minAmount = 0.1; break;
			case 'SOL': minAmount = 0.1; break;
		}
		Swal.fire({
			title: 'Trueque de criptomonedas',
			text: `Conversión de: ${this.amount1} ${this.currency2}. Recibirás aproximadamente ${this.amount2} ${this.currency1}. Incluye comisión Laniakea de 3% (${this.conversionCommissionAmount} ${this.currency1}).`,
			icon: 'info', showCancelButton: true, confirmButtonText: 'Intercambiar', cancelButtonText: 'Cancel',
			color: '#ffffff', background: '#010f4e', position: 'top-end', timerProgressBar: true, toast: true,
		}).then((result: any) => {
			if (result.isConfirmed && this.amount2 > minAmount) {
				this.exchangeAssets();
			} else {
				Swal.fire({ title: 'Error', text: `La cantidad mínima requerida es ${minAmount} ${this.currency2}`, icon: 'error', confirmButtonText: 'Accept', color: '#ffffff', background: '#010f4e', position: 'top-end', timerProgressBar: true, toast: true });
			}
		});
	}
}
